var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import React, { useState, useRef, useEffect, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCircleInfo, faCircleCheck, faTriangleExclamation, faEyeSlash, faEye, faCaretDown, faMoneyBillWave, faChevronLeft, faCoins, faArrowUpFromBracket, faRepeat } from "@fortawesome/free-solid-svg-icons";
import { CSSTransition } from "react-transition-group";
import { QRCodeSVG } from "qrcode.react";
import SyntaxHighlighter from "react-syntax-highlighter";
import ReactDOM from "react-dom";
import { faClone } from "@fortawesome/free-regular-svg-icons";
import BigNumber$1, { BigNumber } from "bignumber.js";
import Identicon from "@polkadot/react-identicon";
var index = "";
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
shouldUseNative() ? Object.assign : function(target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = React, g = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if ("function" === typeof Symbol && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  reactJsxRuntime_production_min.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
function q(c, a, k) {
  var b, d = {}, e = null, l = null;
  void 0 !== k && (e = "" + k);
  void 0 !== a.key && (e = "" + a.key);
  void 0 !== a.ref && (l = a.ref);
  for (b in a)
    n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps)
    for (b in a = c.defaultProps, a)
      void 0 === d[b] && (d[b] = a[b]);
  return { $$typeof: g, type: c, key: e, ref: l, props: d, _owner: m.current };
}
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
const FishAnimation = ({
  className
}) => /* @__PURE__ */ jsx("div", {
  className: "fish-animation",
  children: /* @__PURE__ */ jsx("svg", {
    className: `fish-animation__fish ${className || ""}`,
    viewBox: "0 0 66 29",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      transform: "translate(0 -1)",
      children: [/* @__PURE__ */ jsx("g", {
        transform: "translate(15 .1864)",
        children: /* @__PURE__ */ jsx("path", {
          d: "M5.9856 12.9696l9.514-5.259c.607-.335.829-1.106.493-1.713l-1.25-2.26c-1.508-2.73-4.976-3.729-7.706-2.22l-5.654 3.125c-.606.335-.828 1.105-.493 1.713l3.384 6.121c.335.606 1.106.828 1.712.493",
          fill: "#1E0135"
        })
      }), /* @__PURE__ */ jsx("g", {
        transform: "translate(15 16.1864)",
        children: /* @__PURE__ */ jsx("path", {
          d: "M5.9856.8436l9.514 5.259c.607.336.829 1.106.493 1.713l-1.25 2.261c-1.508 2.73-4.976 3.729-7.706 2.22l-5.654-3.126c-.606-.335-.828-1.105-.493-1.712l3.384-6.121c.335-.607 1.106-.829 1.712-.494",
          fill: "#1E0135"
        })
      }), /* @__PURE__ */ jsx("path", {
        className: "body",
        d: "M13.2576 15.0935s8.722-13.183 26.167-13.183c17.444 0 26.166 13.183 26.166 13.183s-8.722 13.183-26.166 13.183c-17.445 0-26.167-13.183-26.167-13.183",
        fill: "#A0F"
      }), /* @__PURE__ */ jsx("path", {
        d: "M53.5388 10.4021c0 .854.693 1.548 1.547 1.548.855 0 1.548-.694 1.548-1.548 0-.854-.693-1.547-1.548-1.547-.854 0-1.547.693-1.547 1.547",
        fill: "#1E0135"
      }), /* @__PURE__ */ jsx("path", {
        d: "M46.4583 14.991c1.396 0 2.528-1.132 2.528-2.528 0-1.397-1.132-2.528-2.528-2.528M46.4583 20.9304c1.396-.001 2.528-1.133 2.528-2.528 0-1.397-1.132-2.529-2.528-2.529",
        fill: "#FFFF8D"
      }), /* @__PURE__ */ jsx("path", {
        d: "M29.8621 14.991c1.396 0 2.528-1.132 2.528-2.528 0-1.397-1.132-2.528-2.528-2.528M29.8621 20.9304c1.396-.001 2.528-1.133 2.528-2.528 0-1.397-1.132-2.529-2.528-2.529",
        fill: "#EA80FC"
      }), /* @__PURE__ */ jsx("path", {
        d: "M24.3303 17.6208c1.396 0 2.528-1.132 2.528-2.528 0-1.396-1.132-2.528-2.528-2.528",
        fill: "#FFFF8D"
      }), /* @__PURE__ */ jsx("path", {
        d: "M40.926 17.7351c1.396 0 2.528-1.132 2.528-2.527 0-1.397-1.132-2.529-2.528-2.529M40.926 11.5681c1.396-.001 2.528-1.133 2.528-2.528 0-1.397-1.132-2.529-2.528-2.529M40.926 23.6746c1.396 0 2.528-1.132 2.528-2.528 0-1.396-1.132-2.528-2.528-2.528",
        fill: "#EA80FC"
      }), /* @__PURE__ */ jsx("path", {
        d: "M35.3943 17.7351c1.396 0 2.528-1.132 2.528-2.527 0-1.397-1.132-2.529-2.528-2.529M35.3943 11.5681c1.396-.001 2.528-1.133 2.528-2.528 0-1.397-1.132-2.529-2.528-2.529M35.3943 23.6746c1.396 0 2.528-1.132 2.528-2.528 0-1.396-1.132-2.528-2.528-2.528",
        fill: "#FFFF8D"
      }), /* @__PURE__ */ jsx("path", {
        className: "fish-animation__fin",
        d: "M2.0715 24.2458l19.154-9.152-19.154-9.154c-2.762 6.103-2.762 12.204 0 18.306",
        fill: "#A0F"
      })]
    })
  })
});
const ReefLogo = ({
  className
}) => /* @__PURE__ */ jsxs("svg", {
  className: `reef-logo ${className || ""}`,
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "-738.3 104.7 1154.9 583.5",
  style: {
    enableBackground: "new -738.3 104.7 1154.9 583.5"
  },
  xmlSpace: "preserve",
  children: [/* @__PURE__ */ jsx("path", {
    className: "reef-logo__dot",
    d: "M284.1,494.3c-6.9,0-13.4,1.4-19.4,4.3c-6,2.7-11.2,6.4-15.7,11c-4.4,4.7-8,10.1-10.7,16.4\r c-2.4,6-3.7,12.4-3.7,19.1c0,5.3,1,10.5,3,15.4c2,4.7,4.7,8.8,8,12.4c3.6,3.6,7.7,6.3,12.3,8.4c4.7,2.2,9.7,3.3,15,3.3\r c6.5,0,12.6-1.4,18.4-4.3c5.8-2.7,10.8-6.3,15-11c4.4-4.9,7.9-10.5,10.3-16.7c2.7-6.2,4-12.8,4-19.7c0-10.9-3.4-20.1-10.3-27.4\r C303.8,498,295,494.3,284.1,494.3z"
  }), /* @__PURE__ */ jsxs("linearGradient", {
    id: "reef-logo-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: "-738.3109",
    y1: "396.4383",
    x2: "416.5616",
    y2: "396.4383",
    children: [/* @__PURE__ */ jsx("stop", {
      offset: "0",
      style: {
        stopColor: "#A93185"
      }
    }), /* @__PURE__ */ jsx("stop", {
      offset: "1",
      style: {
        stopColor: "#5D3BAD"
      }
    })]
  }), /* @__PURE__ */ jsx("path", {
    className: "reef-logo__reef",
    d: "M412.6,229L412.6,229c-2.7-7.6-6.2-13.8-10.7-18.7c-4.2-4.9-9.2-8.6-15-11\r c-5.6-2.4-11.5-3.7-17.7-3.7c-13.3,0-27.4,2.3-42.1,7c-14.5,4.7-29.4,13-44.7,25.1c-15.4,12-31,28.4-47.1,49.1\r c-15.8,20.7-31.6,47-47.4,78.9h-39.4c-10.7,0-18.8,2.6-24.4,7.7c-5.6,4.9-8.3,10-8.3,15.4c0,5.1,2.2,9.6,6.7,13.4\r c4.5,3.8,12.8,5.7,25,5.7h17.7l-36.9,78.3c-2.2,1.2-5.5,3-9.8,5.6c-5.8,3.6-13.1,7.8-22,12.7c-8.7,4.9-18.5,10.1-29.4,15.7\r c-10.9,5.3-22.2,10.4-33.7,15c-11.4,4.7-22.9,8.6-34.7,11.7c-11.6,2.9-22.5,4.3-32.7,4.3c-9.6,0-17.2-1.8-23-5.3\r c-5.8-3.8-9.2-8.9-10.3-15.4C-37.2,509.3-12,498.2,8,487.3c20.3-11.1,36.4-21.9,48.4-32.4c12-10.7,20.5-21.2,25.4-31.4\r c4.9-10.3,7.3-20.1,7.3-29.4c0-15.8-4.6-28.2-13.7-37.1c-9.1-8.9-22.9-13.4-41.4-13.4c-17.6,0-34.1,2.6-49.7,7.7\r c-15.3,5.1-29.5,11.9-42.4,20.4c-12.9,8.5-24.6,18.3-35,29.4c-10.2,10.9-18.9,22.2-26,33.7c-7.1,11.6-12.6,23.2-16.4,34.8\r c-3.1,9.3-4.9,18-5.4,26.1c-8.1,4.5-17,9.3-27,14.4c-10.9,5.3-22.1,10.4-33.7,15c-11.3,4.7-22.9,8.6-34.7,11.7\r c-11.6,2.9-22.5,4.3-32.7,4.3c-9.6,0-17.2-1.8-23-5.3c-5.8-3.8-9.2-8.9-10.3-15.4c30.3-11.1,55.4-22.2,75.4-33.1\r c20.3-11.1,36.4-21.9,48.4-32.4c12-10.7,20.5-21.2,25.4-31.4c4.9-10.3,7.3-20.1,7.3-29.4c0-15.8-4.6-28.2-13.7-37.1\r c-9.1-8.9-22.9-13.4-41.4-13.4c-17.6,0-34.2,2.6-49.7,7.7c-15.4,5.1-29.5,11.9-42.4,20.4c-12.9,8.5-24.6,18.3-35,29.4\r c-10.2,10.9-18.9,22.2-26,33.7c-7.1,11.6-12.6,23.2-16.4,34.8c-3.8,11.4-5.7,21.8-5.7,31.4c0,5.9,0.5,11.7,1.3,17.4\r c-6.5,4-13.9,7.8-22.3,11.3c-12.7,5.3-27.1,8-43.4,8h-4.7c-1.6,0-3.2-0.1-5-0.3c-8.9-0.7-17.4-5.1-25.4-13.4\r c-8-8.2-15.4-18.2-22-29.7c-6.4-11.8-12-24.2-16.7-37.1c-4.4-13.1-7.7-25-9.7-35.4c14.2-2.5,28.9-6.5,44.1-12\r c15.4-5.6,30.3-12.4,44.7-20.4c14.5-8,28-17.2,40.7-27.4c12.9-10.5,24.1-21.8,33.7-34.1c9.6-12.5,17.1-25.7,22.7-39.8\r c5.8-14.3,8.7-29.2,8.7-44.8c0-23.2-4.8-43.4-14.3-60.8c-9.3-17.4-22-31.7-38.1-43.1c-16-11.6-34.5-20.3-55.4-26.1\r c-20.7-5.8-42.4-8.7-65.1-8.7c-23.1,0-45.1,2.5-65.8,7.3c-20.7,4.7-39.8,11-57.4,19c-17.4,7.8-33,16.9-47.1,27.4\r c-14,10.2-25.9,20.9-35.7,32.1c-9.6,11.1-17,22.3-22.4,33.4c-5.1,11.1-7.7,21.5-7.7,31.1c0,10.2,2.8,18.3,8.3,24.1\r c5.6,5.6,13.9,8.4,25,8.4c8.2,0,15.1-1.9,20.7-5.7c5.6-3.8,10.6-8.7,15-14.7c4.7-6,9.1-12.9,13.4-20.7c4.2-7.8,8.9-15.8,14-24.1\r c5.3-8.2,11.6-16.3,18.7-24.1c7.3-7.8,16.2-14.7,26.7-20.7c10.7-6,23.3-10.9,37.7-14.7c14.7-3.8,32.2-5.7,52.4-5.7\r c18,0,33.5,2.1,46.4,6.4c13.1,4.2,23.8,9.9,32,17c8.5,7.1,14.6,15.5,18.4,25.1c4,9.6,6,19.7,6,30.4c0,14.9-3.8,30.3-11.3,46.1\r c-7.3,15.8-17.5,30.2-30.4,43.1c-12.9,12.9-28,23.6-45.4,32.1c-17.1,8.2-35.4,12.4-54.7,12.4h-4.7c-1.3,0-2.7-0.1-4-0.3\r c5.8-12.3,11.3-24.2,16.7-35.8c5.3-11.8,10-22.6,14-32.4c4-9.8,7.2-18.5,9.7-26.1c2.5-7.6,3.7-13.5,3.7-17.7s-0.7-7.7-2-10.4\r c-1.3-2.9-2.9-5-4.7-6.4c-1.8-1.6-3.8-2.6-6-3c-2.2-0.7-4.1-1-5.7-1c-5.8,0-12.4,3.3-19.7,10c-7.1,6.5-14.8,15.1-23,26.1\r c-8,10.9-16.4,23.5-25,37.8c-8.5,14-16.9,28.6-25.4,43.8L-720,534.8c-2.4,4.7-4.3,9.7-5.7,15c-1.3,5.3-2,10.6-2,15.7\r c0,3.6,0.4,7.3,1.3,11.4c1.1,4,2.9,7.7,5.3,11c2.4,3.3,5.9,6.1,10.3,8.4c4.4,2.2,10.2,3.3,17.4,3.3c8.7,0,16.7-3.1,24-9.4\r c7.3-6.2,14.2-14.4,20.7-24.4c6.5-10.3,12.4-21.7,17.7-34.4c5.3-12.9,10.5-26,15.4-39.1c4.9-13.1,9.5-25.8,13.7-38.1\r c4.2-12.5,8.3-23.3,12.3-32.4c7.1,23.2,15.3,45.2,24.4,66.2c9.1,20.7,19.2,38.9,30.4,54.5c11.1,15.6,23.5,28,37,37.1\r c13.6,9.1,28.4,13.7,44.4,13.7c19.6,0,40.3-4.9,62.1-14.7c10.6-4.8,21.2-11,32-18.4c1.6,2.3,3.2,4.6,5,6.7\r c7.3,8.7,16.1,15.6,26.4,20.7c10.5,5.1,22.4,7.7,35.7,7.7c15.6,0,31.4-2.1,47.4-6.3c16-4,31.4-9.1,46.1-15.4\r c14.9-6.2,28.9-13,42.1-20.4c8-4.6,15.4-8.9,22.2-13.2c3.7,10,8.7,19,15.1,26.9c7.3,8.7,16.1,15.6,26.4,20.7\r c10.5,5.1,22.4,7.7,35.7,7.7c15.6,0,31.4-2.1,47.4-6.3c16-4,31.4-9.1,46.1-15.4c14.9-6.2,28.9-13,42.1-20.4\r c6.7-3.8,12.9-7.4,18.7-11L47.4,647.7c-2.5,5.1-4.3,9.6-5.7,13.4c-1.3,4-2,7.5-2,10.4c0,5.8,2.1,10,6.3,12.7c4.2,2.7,9,4,14.4,4\r c3.8,0,7.9-0.9,12.3-2.7c4.5-1.6,8.8-3.9,13-7c4.2-3.1,8.1-6.9,11.7-11.4c3.6-4.2,6.6-8.9,9-14c3.6-7.1,8.2-16.8,14-29.1\r c5.8-12,12.2-25.5,19.4-40.4c7.1-15.1,14.6-31.1,22.4-47.8c8-16.9,15.9-33.6,23.7-50.1c8-16.5,15.6-32.2,22.7-47.1\r c7.3-15.1,13.9-28.4,19.7-39.8h58.1c9.8-0.2,19.8-0.5,30-0.7c10.5-0.2,21.5-0.6,33-1c6-0.5,10.9-1.3,14.7-2.7\r c3.8-1.6,6.7-3.3,8.7-5.3c2.2-2.2,3.8-4.6,4.7-7c0.9-2.4,1.3-4.9,1.3-7.3c0-4.9-1.3-8.6-4-11c-2.4-2.7-6-4.6-10.7-5.7\r c-4.4-1.1-9.7-1.8-15.7-2c-6-0.2-12.5-0.3-19.4-0.3h-77.8c5.6-13.4,12.7-26.4,21.4-39.1c8.7-12.9,17.7-24.4,27-34.4\r c9.6-10,18.9-18,28-24.1c9.3-6,17.5-9,24.4-9c5.8,0,10.3,2,13.7,6c3.6,4,5.3,10.7,5.3,20c0,2.5-0.2,4.9-0.7,7.4\r c-0.2,2.4-0.3,5.1-0.3,8c0,4.5,1.9,7.8,5.7,10c3.8,2,7.9,3,12.4,3c1.8,0,3.9-0.2,6.3-0.7c2.4-0.7,4.9-1.7,7.3-3c2.4-1.3,4.7-3,6.7-5\r c2-2.2,3.3-4.9,4-8c2.7-11.6,4-22.2,4-31.7C416.6,245.1,415.2,236.4,412.6,229z M-306.7,479.8c1.3-3.8,2.9-8.2,4.9-13.5\r c2.7-6.2,5.9-12.7,9.7-19.4c3.8-6.9,8-13.8,12.7-20.7c4.9-6.9,10.3-13,16.4-18.4c6.2-5.6,13-10,20.4-13.4c7.3-3.3,15.2-5,23.7-5h3\r c0.9,0,1.9,0.1,3,0.3c2.7,0.5,5,1.7,7,3.7c2.2,2,3.3,4.7,3.3,8c0,4-1.9,8.8-5.7,14.4c-3.8,5.4-10.7,11.1-20.7,17.4\r c-2.2,1.3-6.1,3.9-11.7,7.7c-5.3,3.8-11.7,8-19,12.7c-7.3,4.7-15.2,9.6-23.7,14.7c-7.6,4.7-15,9-22.3,12.7\r C-306,480.6-306.3,480.2-306.7,479.8z M-66.8,466.3c2.7-6.2,5.9-12.7,9.7-19.4c3.8-6.9,8-13.8,12.7-20.7c4.9-6.9,10.3-13,16.4-18.4\r c6.2-5.6,13-10,20.4-13.4c7.3-3.3,15.2-5,23.7-5h3c0.9,0,1.9,0.1,3,0.3c2.7,0.5,5,1.7,7,3.7c2.2,2,3.3,4.7,3.3,8\r c0,4-1.9,8.8-5.7,14.4C22.9,421.2,16,427,6,433.2c-2.2,1.3-6.1,3.9-11.7,7.7c-5.3,3.8-11.7,8-19,12.7c-7.3,4.7-15.2,9.6-23.7,14.7\r c-8.2,5.1-16.2,9.7-24,13.7C-71.1,477.8-69.2,472.5-66.8,466.3z"
  })]
});
const ReefTestnetLogo = ({
  className
}) => /* @__PURE__ */ jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.1",
  className: `reef-logo ${className || ""}`,
  width: "113",
  height: "62",
  viewBox: "0 0 113 62",
  fill: "none",
  children: [/* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.8204 38.0034C99.1477 38.0034 98.518 38.1442 97.9321 38.4267C97.3464 38.6875 96.8358 39.0466 96.4013 39.5026C95.9674 39.9593 95.6204 40.4914 95.3599 41.0994C95.1211 41.6865 95.002 42.3058 95.002 42.9577C95.002 43.4793 95.0995 43.9792 95.2951 44.4569C95.4902 44.9136 95.7506 45.3152 96.0767 45.6632C96.4235 46.0111 96.8253 46.2824 97.281 46.4776C97.7364 46.6952 98.2254 46.804 98.7457 46.804C99.3754 46.804 99.9716 46.6631 100.537 46.38C101.102 46.1192 101.59 45.7608 102.003 45.3041C102.436 44.8265 102.772 44.2833 103.011 43.6752C103.272 43.0664 103.402 42.4256 103.402 41.7521C103.402 40.6873 103.065 39.7962 102.393 39.0793C101.741 38.3618 100.884 38.0034 99.8204 38.0034Z",
    fill: "url(#paint0_linear_3165_204853)"
  }), /* @__PURE__ */ jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5013 35.2672C65.7612 34.6584 66.0767 34.0281 66.4452 33.3767C66.8149 32.7025 67.2273 32.0295 67.6828 31.356C68.1607 30.6817 68.6921 30.0842 69.2786 29.5626C69.8859 29.0194 70.5483 28.5849 71.2644 28.2593C71.9804 27.9336 72.7514 27.7705 73.5761 27.7705H73.8693C73.9557 27.7705 74.0526 27.7809 74.1612 27.8025C74.4224 27.8465 74.6502 27.9657 74.8452 28.1616C75.0625 28.357 75.1711 28.6178 75.1711 28.944C75.1711 29.3345 74.9866 29.8024 74.6181 30.345C74.2489 30.8672 73.5761 31.4313 72.5996 32.0401C72.3823 32.1704 72.0026 32.4208 71.4601 32.7896C70.939 33.1592 70.3199 33.572 69.6039 34.0281C68.8878 34.4848 68.1168 34.9631 67.2915 35.4624C66.489 35.9623 65.7075 36.4079 64.9483 36.7991C65.0786 36.3863 65.2631 35.8751 65.5013 35.2672ZM43.5247 33.3767C43.8931 32.7025 44.3056 32.0295 44.7617 31.356C45.2394 30.6817 45.771 30.0842 46.3574 29.5626C46.9648 29.0194 47.6265 28.5849 48.3432 28.2593C49.0599 27.9336 49.8303 27.7705 50.655 27.7705H50.9482C51.0346 27.7705 51.1321 27.7809 51.2407 27.8025C51.5012 27.8465 51.7291 27.9657 51.9247 28.1616C52.142 28.357 52.2506 28.6178 52.2506 28.944C52.2506 29.3345 52.0661 29.8024 51.697 30.345C51.3278 30.8672 50.655 31.4313 49.6778 32.0401C49.4612 32.1704 49.0815 32.4208 48.5383 32.7896C48.0179 33.1592 47.3995 33.572 46.6827 34.0281C45.966 34.4848 45.1963 34.9631 44.371 35.4624C43.6281 35.925 42.9055 36.3358 42.1992 36.7054C42.1685 36.6628 42.1364 36.6209 42.1004 36.5822C42.2248 36.208 42.3793 35.7801 42.5802 35.2672C42.8407 34.6584 43.1555 34.0281 43.5247 33.3767ZM112.255 12.1253C111.995 11.3862 111.647 10.7774 111.213 10.2998C110.801 9.82143 110.312 9.46301 109.749 9.22385C109.206 8.98534 108.631 8.86543 108.023 8.86543C106.721 8.86543 105.353 9.09345 103.921 9.5495C102.51 10.0062 101.055 10.8213 99.5578 11.9942C98.0603 13.1678 96.53 14.7652 94.9671 16.786C93.4256 18.8067 91.8849 21.3707 90.3435 24.4785H86.5015C85.4601 24.4785 84.6676 24.7282 84.1249 25.2282C83.5824 25.7058 83.3107 26.2058 83.3107 26.7273C83.3107 27.2266 83.5281 27.6617 83.962 28.0313C84.3965 28.4008 85.2101 28.5849 86.4039 28.5849H88.1299L84.5307 36.2205C84.3115 36.3351 83.994 36.516 83.5713 36.7663C83.007 37.1142 82.2903 37.5271 81.4224 38.0047C80.5762 38.483 79.6213 38.9935 78.5577 39.5367C77.4941 40.0583 76.3971 40.5477 75.2693 41.0037C74.1612 41.4598 73.0335 41.8405 71.8829 42.1445C70.7545 42.4269 69.6909 42.5685 68.6921 42.5685C67.7588 42.5685 67.01 42.3942 66.4452 42.0469C65.8816 41.6774 65.5452 41.1774 65.4366 40.5477C68.3884 39.4606 70.8409 38.3854 72.7946 37.3206C74.77 36.2342 76.3435 35.18 77.5157 34.1591C78.6879 33.116 79.5126 32.0944 79.9897 31.0952C80.4676 30.0953 80.7064 29.1392 80.7064 28.2265C80.7064 26.6834 80.2613 25.4778 79.3705 24.6083C78.4818 23.7394 77.136 23.305 75.3335 23.305C73.6193 23.305 72.0026 23.5546 70.4822 24.0546C68.9853 24.5545 67.6069 25.217 66.3483 26.0426C65.089 26.8689 63.9495 27.8249 62.9298 28.9113C61.931 29.9761 61.0847 31.0736 60.3896 32.2031C59.6951 33.3328 59.1637 34.4632 58.7946 35.5934C58.4921 36.4996 58.3206 37.3456 58.2657 38.1357C57.4776 38.576 56.6045 39.0427 55.6364 39.5367C54.5728 40.0583 53.4765 40.5477 52.3475 41.0037C51.2407 41.4598 50.1117 41.8405 48.9617 42.1445C47.8333 42.4269 46.7698 42.5685 45.771 42.5685C44.8376 42.5685 44.0888 42.3942 43.5247 42.0469C42.9604 41.6774 42.6241 41.1774 42.5154 40.5477C45.4673 39.4606 47.9204 38.3854 49.8735 37.3206C51.8488 36.2342 53.4222 35.18 54.5944 34.1591C55.7668 33.116 56.5914 32.0944 57.0686 31.0952C57.5463 30.0953 57.7853 29.1392 57.7853 28.2265C57.7853 26.6834 57.3402 25.4778 56.45 24.6083C55.5605 23.7394 54.2149 23.305 52.413 23.305C50.6982 23.305 49.0815 23.5546 47.5618 24.0546C46.0642 24.5545 44.6858 25.217 43.4265 26.0426C42.1685 26.8689 41.0283 27.8249 40.0086 28.9113C39.0098 29.9761 38.1629 31.0736 37.4691 32.2031C36.774 33.3328 36.2425 34.4632 35.8733 35.5934C35.5042 36.7007 35.3203 37.7223 35.3203 38.6567C35.3203 39.2346 35.3648 39.7994 35.4479 40.3531C34.8104 40.7449 34.0925 41.1152 33.275 41.4598C32.0373 41.9814 30.6267 42.2421 29.0422 42.2421H28.5866C28.4341 42.2421 28.2712 42.231 28.0984 42.2094C27.2292 42.1445 26.4051 41.7101 25.6229 40.9054C24.8422 40.1015 24.1255 39.135 23.4742 38.0047C22.8453 36.8534 22.3026 35.6472 21.8465 34.3871C21.4125 33.1048 21.0977 31.9529 20.902 30.932C22.2915 30.6929 23.7243 30.3017 25.2002 29.7585C26.6977 29.2153 28.1527 28.5522 29.5632 27.7705C30.9737 26.9881 32.2984 26.0969 33.5348 25.0971C34.794 24.0762 35.8903 22.9682 36.8237 21.773C37.7564 20.5563 38.4947 19.2634 39.0373 17.894C39.6022 16.5036 39.8836 15.0476 39.8836 13.5262C39.8836 11.2668 39.4169 9.28937 38.4842 7.59426C37.5725 5.89915 36.3348 4.49824 34.7724 3.38957C33.2095 2.25927 31.4076 1.41205 29.3675 0.847228C27.3489 0.282409 25.2329 0 23.0187 0C20.7613 0 18.6236 0.239163 16.6051 0.716835C14.5859 1.17289 12.7192 1.79275 11.0043 2.57445C9.31114 3.33518 7.78089 4.22631 6.41425 5.24784C5.04632 6.24708 3.88521 7.29022 2.92962 8.37662C1.99693 9.46301 1.26977 10.5494 0.748766 11.6358C0.250025 12.7222 0 13.7332 0 14.6676C0 15.6668 0.271624 16.4492 0.813563 17.014C1.35615 17.5572 2.17037 17.8291 3.25557 17.8291C4.05866 17.8291 4.7315 17.6443 5.27409 17.2748C5.81734 16.9052 6.3056 16.4276 6.73955 15.8411C7.1951 15.2541 7.62969 14.5804 8.04204 13.8197C8.45438 13.0589 8.90993 12.2773 9.40932 11.4733C9.93031 10.6687 10.5377 9.88695 11.2329 9.12622C11.9488 8.36548 12.8174 7.69254 13.8371 7.10545C14.8791 6.51835 16.105 6.04068 17.5169 5.67112C18.9489 5.30157 20.6533 5.11678 22.628 5.11678C24.3866 5.11678 25.8947 5.32318 27.1533 5.73664C28.4341 6.14944 29.4761 6.70313 30.2792 7.39899C31.1039 8.09421 31.7008 8.90868 32.07 9.84306C32.4607 10.7774 32.6557 11.7662 32.6557 12.8094C32.6557 14.2653 32.2873 15.7644 31.549 17.3076C30.8322 18.85 29.8447 20.2515 28.5866 21.5122C27.3273 22.7722 25.8515 23.8154 24.1582 24.641C22.4865 25.445 20.7076 25.8474 18.8187 25.8474H18.3624C18.2322 25.8474 18.1026 25.8363 17.9724 25.8145C18.5366 24.6194 19.0791 23.457 19.6002 22.3267C20.1211 21.1755 20.5767 20.1212 20.9674 19.1651C21.3581 18.2092 21.673 17.3619 21.9113 16.6228C22.1508 15.8838 22.2699 15.3084 22.2699 14.8956C22.2699 14.4828 22.2051 14.146 22.0742 13.8853C21.944 13.6028 21.7928 13.3964 21.6187 13.2654C21.4445 13.1134 21.2502 13.0157 21.0329 12.9724C20.8156 12.907 20.631 12.8748 20.4791 12.8748C19.915 12.8748 19.2742 13.2005 18.5582 13.8525C17.8637 14.4828 17.1149 15.3301 16.3118 16.3948C15.5297 17.4596 14.7162 18.6875 13.8698 20.0779C13.0445 21.4468 12.2204 22.8706 11.3952 24.3475L1.79076 41.9486C1.55185 42.4053 1.36728 42.8941 1.23703 43.4157C1.10679 43.9373 1.04199 44.4477 1.04199 44.9476C1.04199 45.2956 1.08519 45.6645 1.17224 46.0557C1.28089 46.4469 1.45433 46.8053 1.69324 47.1316C1.93148 47.4572 2.26855 47.7291 2.70249 47.9461C3.13645 48.1636 3.70063 48.2723 4.39573 48.2723C5.24202 48.2723 6.02352 47.9677 6.73955 47.3596C7.45559 46.7509 8.12909 45.9581 8.75808 44.9805C9.38772 43.9805 9.96305 42.8614 10.4834 41.6229C11.0043 40.3622 11.5038 39.0911 11.9809 37.8095C12.4587 36.5272 12.9044 35.2888 13.3168 34.0935C13.7285 32.8768 14.1303 31.8231 14.5205 30.932C15.2155 33.1919 16.0081 35.3431 16.8976 37.3855C17.7878 39.4063 18.7748 41.1774 19.8607 42.6982C20.9458 44.2197 22.1508 45.4254 23.4742 46.3164C24.7983 47.2075 26.2422 47.6531 27.8045 47.6531C29.7143 47.6531 31.7335 47.1748 33.8607 46.2188C34.8902 45.7503 35.9303 45.1481 36.9801 44.4201C37.1327 44.6476 37.2957 44.867 37.4691 45.0781C38.1852 45.9253 39.0425 46.5989 40.0413 47.0988C41.061 47.5988 42.2221 47.8485 43.5247 47.8485C45.0438 47.8485 46.5852 47.642 48.1475 47.2293C49.7105 46.838 51.2087 46.3381 52.6415 45.73C54.0951 45.1213 55.4623 44.4589 56.7433 43.7414C57.528 43.2965 58.246 42.8692 58.913 42.4552C59.2743 43.434 59.7618 44.3121 60.3896 45.0781C61.1063 45.9253 61.9637 46.5989 62.9619 47.0988C63.9823 47.5988 65.1434 47.8485 66.4452 47.8485C67.9649 47.8485 69.5063 47.642 71.0693 47.2293C72.6316 46.838 74.1298 46.3381 75.5619 45.73C77.0162 45.1213 78.3836 44.4589 79.6644 43.7414C80.3137 43.3731 80.9224 43.016 81.4906 42.6694L76.6367 52.9659C76.3971 53.4658 76.2131 53.9002 76.0829 54.2691C75.9526 54.6609 75.8878 54.9978 75.8878 55.2801C75.8878 55.845 76.094 56.2578 76.5058 56.5186C76.9187 56.7794 77.3854 56.9097 77.9064 56.9097C78.2755 56.9097 78.6768 56.8226 79.1107 56.6489C79.5453 56.497 79.9681 56.2689 80.3804 55.9643C80.7935 55.6602 81.1731 55.2913 81.52 54.8563C81.8675 54.4434 82.1607 53.9874 82.3989 53.4874C82.7466 52.7923 83.2027 51.8467 83.767 50.6516C84.3311 49.478 84.9608 48.1636 85.6553 46.7077C86.3496 45.23 87.0768 43.6765 87.8367 42.0469C88.6182 40.3951 89.3885 38.7654 90.1485 37.1575C90.93 35.5496 91.6675 34.0176 92.362 32.5616C93.0788 31.084 93.7188 29.7913 94.283 28.6832H97.1158H99.9485C100.903 28.661 101.88 28.6394 102.878 28.6178C103.899 28.5961 104.973 28.5633 106.102 28.52C106.688 28.4762 107.165 28.3897 107.534 28.2593C107.904 28.1073 108.186 27.9336 108.381 27.7377C108.598 27.5201 108.75 27.2922 108.837 27.053C108.924 26.8144 108.967 26.5753 108.967 26.3361C108.967 25.8579 108.837 25.4994 108.576 25.2609C108.338 25.0001 107.991 24.8147 107.534 24.7066C107.1 24.5978 106.591 24.5329 106.004 24.5107C105.418 24.4891 104.788 24.4785 104.116 24.4785H96.53C97.072 23.1746 97.767 21.9035 98.6133 20.6644C99.4603 19.4043 100.339 18.2852 101.25 17.3076C102.184 16.33 103.095 15.5476 103.986 14.9605C104.897 14.3741 105.689 14.0805 106.362 14.0805C106.927 14.0805 107.371 14.2758 107.697 14.6676C108.044 15.0588 108.218 15.7101 108.218 16.6228C108.218 16.862 108.196 17.1011 108.153 17.3403C108.131 17.5789 108.121 17.8397 108.121 18.1221C108.121 18.5572 108.305 18.8828 108.674 19.1004C109.043 19.2956 109.444 19.3932 109.879 19.3932C110.053 19.3932 110.259 19.3716 110.498 19.3283C110.737 19.2634 110.974 19.1651 111.213 19.0348C111.452 18.9044 111.669 18.7419 111.865 18.5459C112.061 18.3284 112.191 18.0676 112.255 17.7637C112.516 16.634 112.647 15.602 112.647 14.6676C112.647 13.6893 112.516 12.8421 112.255 12.1253Z",
    fill: "#6A27EA"
  }), /* @__PURE__ */ jsx("path", {
    d: "M3.63846 54.8598V53.8829H2.18024V52H0.991021V53.8829H0V54.8598H0.991021V59.7441C0.991021 60.8484 1.65642 61.3298 2.63328 61.3298C2.97306 61.3298 3.36947 61.2731 3.6243 61.0749V60.1264C3.35531 60.2255 3.12879 60.2538 2.9589 60.2538C2.40676 60.2538 2.18024 59.9706 2.18024 59.5176V54.8598H3.63846Z",
    fill: "#6A27EA"
  }), /* @__PURE__ */ jsx("path", {
    d: "M8.27071 53.7414C6.41608 53.7414 4.60393 55.0863 4.60393 57.5639C4.60393 60.0131 6.40193 61.3864 8.38397 61.3864C9.57319 61.3864 10.635 60.905 11.3004 60.0839L10.7058 59.4751C10.1678 60.0556 9.37499 60.367 8.51138 60.367C7.09564 60.367 5.92057 59.5459 5.73653 58.0028H11.7959C12.0932 55.0863 10.1395 53.7414 8.27071 53.7414ZM8.28486 54.7749C9.51656 54.7749 10.6633 55.5818 10.7483 57.0967H5.73653C5.92057 55.5535 7.06733 54.7749 8.28486 54.7749Z",
    fill: "#6A27EA"
  }), /* @__PURE__ */ jsx("path", {
    d: "M15.1152 61.3864C16.446 61.3864 17.6777 60.7068 17.6777 59.2486C17.6777 58.0311 16.8282 57.5214 15.6673 57.0684L15.0727 56.8277C14.3082 56.5162 14.0109 56.1481 14.0109 55.6809C14.0109 55.058 14.5206 54.7182 15.1576 54.7182C15.8089 54.7182 16.2478 55.058 16.4743 55.6668L17.4228 55.3836C17.168 54.3926 16.2902 53.7414 15.1152 53.7414C13.841 53.7414 12.8358 54.5059 12.8358 55.6668C12.8358 56.5021 13.3455 57.2241 14.563 57.7196L15.2284 57.9744C16.0779 58.3284 16.5026 58.6398 16.5026 59.2486C16.5026 60.0556 15.8089 60.3954 15.1152 60.3954C14.294 60.3954 13.7136 59.8998 13.5154 59.1212L12.5244 59.3902C12.7509 60.6502 13.7419 61.3864 15.1152 61.3864Z",
    fill: "#6A27EA"
  }), /* @__PURE__ */ jsx("path", {
    d: "M22.1371 54.8598V53.8829H20.6789V52H19.4897V53.8829H18.4987V54.8598H19.4897V59.7441C19.4897 60.8484 20.1551 61.3298 21.132 61.3298C21.4717 61.3298 21.8681 61.2731 22.123 61.0749V60.1264C21.854 60.2255 21.6275 60.2538 21.4576 60.2538C20.9054 60.2538 20.6789 59.9706 20.6789 59.5176V54.8598H22.1371Z",
    fill: "#6A27EA"
  }), /* @__PURE__ */ jsx("path", {
    d: "M27.1783 53.7414C25.9041 53.7414 25.0971 54.3784 24.7149 55.0863V53.8829H23.5257V61.2448H24.7149V57.0825C24.7149 55.596 25.6351 54.8315 26.8102 54.8315C27.9853 54.8315 28.863 55.596 28.863 57.0825V61.2448H30.0523V56.9126C30.0523 54.7041 28.7215 53.7414 27.1783 53.7414Z",
    fill: "#6A27EA"
  }), /* @__PURE__ */ jsx("path", {
    d: "M35.0371 53.7414C33.1825 53.7414 31.3703 55.0863 31.3703 57.5639C31.3703 60.0131 33.1683 61.3864 35.1504 61.3864C36.3396 61.3864 37.4014 60.905 38.0668 60.0839L37.4722 59.4751C36.9342 60.0556 36.1414 60.367 35.2778 60.367C33.862 60.367 32.687 59.5459 32.5029 58.0028H38.5623C38.8596 55.0863 36.9059 53.7414 35.0371 53.7414ZM35.0513 54.7749C36.283 54.7749 37.4297 55.5818 37.5147 57.0967H32.5029C32.687 55.5535 33.8337 54.7749 35.0513 54.7749Z",
    fill: "#6A27EA"
  }), /* @__PURE__ */ jsx("path", {
    d: "M43 54.8598V53.8829H41.5418V52H40.3526V53.8829H39.3615V54.8598H40.3526V59.7441C40.3526 60.8484 41.018 61.3298 41.9948 61.3298C42.3346 61.3298 42.731 61.2731 42.9858 61.0749V60.1264C42.7169 60.2255 42.4903 60.2538 42.3204 60.2538C41.7683 60.2538 41.5418 59.9706 41.5418 59.5176V54.8598H43Z",
    fill: "#6A27EA"
  }), /* @__PURE__ */ jsx("defs", {
    children: /* @__PURE__ */ jsxs("linearGradient", {
      id: "paint0_linear_3165_204853",
      x1: "99.202",
      y1: "38.0034",
      x2: "99.202",
      y2: "46.804",
      gradientUnits: "userSpaceOnUse",
      children: [/* @__PURE__ */ jsx("stop", {
        stopColor: "#681CFF"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "1",
        stopColor: "#FD3F83"
      })]
    })
  })]
});
const ReefIcon = ({
  className
}) => /* @__PURE__ */ jsxs("svg", {
  className: `reef-icon ${className || ""}`,
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "-835.8 471.9 595.8 595.8",
  style: {
    enableBackground: "new -835.8 471.9 595.8 595.8"
  },
  xmlSpace: "preserve",
  children: [/* @__PURE__ */ jsxs("linearGradient", {
    id: "reef-icon-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: "-537.9",
    y1: "322.9777",
    x2: "-537.9",
    y2: "-271.9",
    gradientTransform: "matrix(1 0 0 -1 0 795.8)",
    children: [/* @__PURE__ */ jsx("stop", {
      offset: "0",
      style: {
        stopColor: "#BE29C0"
      }
    }), /* @__PURE__ */ jsx("stop", {
      offset: "1",
      style: {
        stopColor: "#9D00F5"
      }
    })]
  }), /* @__PURE__ */ jsx("circle", {
    className: "reef-icon__circle",
    cx: "-537.9",
    cy: "769.8",
    r: "297.9"
  }), /* @__PURE__ */ jsx("path", {
    className: "reef-icon__r",
    d: "M-558.9,584.4c23.5-3.7,47-3.7,70.5,1.2c18.5,3.7,37.1,11.1,51.9,22.2c9.9,7.4,18.5,17.3,24.7,28.4\r c7.4,12.4,11.1,28.4,11.1,43.3c0,11.1-1.2,22.2-4.9,32.1c-6.2,17.3-17.3,33.4-30.9,45.7c-17.3,16.1-37.1,29.7-58.1,38.3\r c-14.8,6.2-29.7,11.1-45.7,14.8c2.5,14.8,7.4,29.7,14.8,43.3c4.9,11.1,12.4,22.2,21,30.9c3.7,2.5,6.2,4.9,11.1,7.4\r c4.9,2.5,9.9,1.2,14.8,1.2c7.4,0,16.1-1.2,23.5-3.7c17.3-6.2,33.4-16.1,45.7-29.7c3.7-4.9,7.4-9.9,13.6-11.1\r c4.9-2.5,11.1-1.2,14.8,3.7c2.5,3.7,2.5,8.7,1.2,13.6c-1.2,4.9-3.7,9.9-6.2,13.6c-2.5,3.7-6.2,7.4-9.9,11.1\r c-11.1,9.9-23.5,19.8-35.8,27.2c-13.6,7.4-28.4,13.6-44.5,14.8c-11.1,1.2-22.2,1.2-32.1-3.7c-13.6-6.2-24.7-16.1-33.4-27.2\r c-9.9-13.6-18.5-27.2-24.7-43.3c-7.4-16.1-13.6-32.1-18.5-49.4c-4.9,11.1-8.7,22.2-12.4,33.4c-6.2,16.1-11.1,30.9-17.3,45.7\r c-6.2,14.8-13.6,29.7-26,39.6c-4.9,4.9-12.4,8.7-19.8,7.4c-6.2,0-13.6-2.5-17.3-7.4c-2.5-3.7-4.9-8.7-4.9-13.6\r c-1.2-9.9,1.2-18.5,6.2-27.2c13.6-23.5,26-48.2,39.6-71.7c18.5-33.4,35.8-66.7,55.6-97.7c8.7-13.6,17.3-27.2,29.7-37.1\r c3.7-3.7,8.7-6.2,13.6-7.4c4.9,0,9.9,2.5,11.1,6.2c3.7,7.4,1.2,16.1-1.2,23.5c-7.4,22.2-18.5,44.5-28.4,65.5\r c12.4,1.2,26-1.2,37.1-4.9c12.4-4.9,24.7-12.4,34.6-21h-1.2h1.2c17.3-13.6,29.7-33.4,34.6-55.6c3.7-14.8,1.2-30.9-6.2-43.3\r c-6.2-9.9-16.1-17.3-27.2-21c-14.8-6.2-30.9-7.4-47-6.2c-11.1,0-23.5,1.2-33.4,4.9c-14.8,4.9-29.7,12.4-40.8,23.5\r c-6.2,6.2-11.1,13.6-16.1,21c-7.4,12.4-13.6,26-24.7,35.8c-4.9,4.9-12.4,7.4-18.5,7.4c-7.4,0-14.8-1.2-19.8-7.4\r c-4.9-6.2-4.9-14.8-3.7-22.2c2.5-14.8,11.1-27.2,19.8-37.1c9.9-12.4,22.2-22.2,35.8-30.9C-614.5,599.2-587.3,589.3-558.9,584.4z"
  })]
});
const ReefSign = ({
  className
}) => /* @__PURE__ */ jsx("svg", {
  className: `reef-sign ${className || ""}`,
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "-675 594.5 293 336.9",
  style: {
    enableBackground: "new -675 594.5 293 336.9"
  },
  xmlSpace: "preserve",
  children: /* @__PURE__ */ jsx("path", {
    className: "reef-sign__sign",
    d: "M-548.6,774.1h3.3c13,0,25.5-2.7,36.9-8.1c11.9-6,21.7-13,30.4-21.7c8.7-8.7,15.7-18.4,20.6-29.3\r c4.9-10.9,7.6-21.2,7.6-31.5c0-7.1-1.1-14.1-3.8-20.6c-2.7-6.5-6.5-11.9-12.5-16.8c-5.4-4.9-12.5-8.7-21.7-11.4\r c-8.7-2.7-19-4.3-30.9-4.3c-13.6,0-25.5,1.1-35.3,3.8c-9.8,2.7-17.9,6-25.5,9.8c-7.1,4.3-13,8.7-17.9,14.1\r c-4.9,5.4-9.2,10.9-12.5,16.3c-3.3,5.4-6.5,10.9-9.2,16.3c-2.7,5.4-6,9.8-9.2,14.1c-3.3,4.3-6.5,7.6-10.3,9.8\r c-3.8,2.2-8.1,3.8-14.1,3.8c-7.6,0-13-1.6-16.8-5.4s-5.4-9.2-5.4-16.3c0-6.5,1.6-13.6,5.4-21.2c3.8-7.6,8.7-15.2,15.2-22.8\r c6.5-7.6,14.6-14.6,23.9-21.7c9.2-7.1,20.1-13.6,31.5-18.4c11.9-5.4,24.4-9.8,38.5-13s28.8-4.9,43.9-4.9s29.8,2.2,43.9,6\r c14.1,3.8,26.6,9.8,37.4,17.9c10.9,7.6,19.5,17.4,25.5,29.3c6.5,11.9,9.8,25.5,9.8,41.2c0,10.9-2.2,20.6-6,30.4\r c-3.8,9.8-8.7,18.4-15.2,27.1c-6.5,8.1-14.1,16.3-22.8,23.3c-8.7,7.1-17.9,13-27.1,18.4c-9.8,5.4-19.5,10.3-29.8,14.1\r c-10.3,3.8-20.1,6.5-29.8,8.1c1.1,7.1,3.3,15.2,6.5,23.9c3.3,8.7,7.1,17.4,11.4,25c4.3,8.1,9.2,14.6,14.6,20.1\r c5.4,5.4,10.9,8.7,16.8,9.2c1.1,0,2.2,0,3.3,0h3.3c10.9,0,20.6-1.6,29.3-5.4c8.7-3.8,15.7-7.6,21.2-11.9\r c6.5-4.9,12.5-10.9,17.4-17.4c4.9-5.4,9.2-8.1,14.1-8.1c3.3,0,5.4,1.1,7.6,3.3c2.2,2.2,3.3,4.9,3.3,8.7c0,3.3-1.1,7.6-3.3,12.5\r c-2.2,4.3-6,9.2-10.9,14.1c-15.2,14.6-30.4,25.5-45.6,32c-14.6,6.5-28.8,9.8-41.8,9.8c-10.9,0-20.6-3.3-29.8-9.2\r c-9.2-6-17.4-14.6-25-25c-7.6-10.9-14.1-22.8-20.6-36.9c-6-14.1-11.4-29.3-16.3-45c-2.7,6-5.4,13.6-8.1,22.2c-2.7,8.1-6,16.8-9.2,26\r c-3.3,8.7-6.5,17.9-10.3,26.6c-3.8,8.7-7.6,16.3-11.9,23.3c-4.3,7.1-9.2,12.5-14.1,16.8c-4.9,4.3-10.3,6.5-16.3,6.5\r c-4.9,0-8.7-0.5-11.9-2.2c-3.3-1.6-5.4-3.3-7.1-5.4c-1.6-2.2-2.7-4.9-3.8-7.6c-0.5-2.7-1.1-5.4-1.1-7.6c0-3.3,0.5-7.1,1.1-10.9\r c1.1-3.8,2.2-7.1,3.8-10.3l66.2-122.6c5.4-10.3,11.4-20.1,16.8-29.8c6-9.8,11.4-18.4,16.8-25.5c5.4-7.6,10.9-13.6,15.7-17.9\r s9.2-7.1,13-7.1c1.1,0,2.2,0,3.8,0.5c1.6,0.5,2.7,1.1,3.8,2.2c1.1,1.1,2.2,2.2,3.3,4.3c1.1,1.6,1.1,4.3,1.1,7.1s-1.1,7.1-2.7,11.9\r c-1.6,4.9-3.8,10.9-6.5,17.9c-2.7,6.5-6,14.1-9.2,22.2c-3.8,8.1-7.6,15.7-11.4,24.4C-550.2,774.1-549.7,774.1-548.6,774.1\r L-548.6,774.1z"
  })
});
const random = (min, max) => {
  return Math.random() * (max - min) + min;
};
const Bubbles = ({
  amount,
  delay,
  className
}) => /* @__PURE__ */ jsx("div", {
  className: `
      uik-bubbles
      ${className || ""}
    `,
  children: (() => {
    let output = [];
    for (let i = 0; i < (amount || 20); i++) {
      output.push(/* @__PURE__ */ jsx("div", {
        className: "uik-bubbles__bubble",
        style: {
          animationDelay: `${i * (delay || 0.5) - 0.1}s`,
          left: `${random(0, 100)}%`,
          transform: `scale(${random(0.75, 1.25)})`,
          opacity: random(0.5, 1)
        }
      }, i));
    }
    return output;
  })()
});
const assets = {
  FishAnimation,
  ReefLogo,
  ReefTestnetLogo,
  ReefIcon,
  Bubbles,
  ReefSign
};
const Icon = ({
  icon,
  className
}) => /* @__PURE__ */ jsx(FontAwesomeIcon, {
  className: `uik-icon ${className || ""}`,
  icon
});
const getIcon = (type) => {
  const map = {
    success: faCircleCheck,
    danger: faTriangleExclamation
  };
  return map[type] || faCircleInfo;
};
const Alert = ({
  type,
  text,
  onClose,
  aliveFor,
  className,
  children
}) => {
  const [closing, setClosing] = useState(false);
  const close = () => {
    if (onClose && !closing) {
      setClosing(true);
      onClose();
    }
  };
  const actions = useRef(null);
  useEffect(() => {
    if (actions.current) {
      const buttons = actions.current.children;
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener("click", close);
      }
    }
    if (onClose && aliveFor) {
      const timer = setTimeout(() => {
        close();
      }, 1e3 * aliveFor);
      return () => clearTimeout(timer);
    }
    return () => {
    };
  }, []);
  return /* @__PURE__ */ jsxs("div", {
    className: `
        uik-alert
        uik-alert--${type}
        ${closing ? "uik-alert--close" : ""}
        ${!!onClose && !!aliveFor ? "uik-alert--autoclose" : ""}
        ${className || ""}
      `,
    style: onClose && aliveFor ? {
      "--alive-for": `${aliveFor}s`
    } : {},
    children: [/* @__PURE__ */ jsxs("div", {
      className: "uik-alert__content",
      children: [/* @__PURE__ */ jsx(Icon, {
        className: "uik-alert__icon",
        icon: getIcon(type)
      }), /* @__PURE__ */ jsx("div", {
        className: "uik-alert__text",
        children: text
      }), !!onClose && /* @__PURE__ */ jsx("button", {
        className: "uik-alert__close-btn",
        onClick: close,
        children: /* @__PURE__ */ jsx(Icon, {
          className: "uik-alert__close-btn-icon",
          icon: faXmark
        })
      })]
    }), !!children && /* @__PURE__ */ jsx("div", {
      ref: actions,
      className: "uik-alert__buttons",
      children
    })]
  });
};
const Loading = ({
  color,
  size,
  text,
  className
}) => /* @__PURE__ */ jsxs("div", {
  className: `
      uik-loading
      ${color === "white" ? "uik-loading--white" : ""}
      ${color === "black" ? "uik-loading--black" : ""}
      ${size === "small" ? "uik-loading--small" : ""}
      ${className || ""}
    `,
  children: [/* @__PURE__ */ jsxs("div", {
    className: "uik-loading__spinner",
    children: [/* @__PURE__ */ jsx("div", {
      className: "uik-loading__spinner-dot"
    }), /* @__PURE__ */ jsx("div", {
      className: "uik-loading__spinner-dot"
    }), /* @__PURE__ */ jsx("div", {
      className: "uik-loading__spinner-dot"
    }), /* @__PURE__ */ jsx("div", {
      className: "uik-loading__spinner-dot"
    }), /* @__PURE__ */ jsx("div", {
      className: "uik-loading__spinner-dot"
    }), /* @__PURE__ */ jsx("div", {
      className: "uik-loading__spinner-dot"
    })]
  }), !!text && /* @__PURE__ */ jsx("div", {
    className: "uik-loading__text",
    children: text
  })]
});
const Button = ({
  danger: danger2,
  fill,
  neomorph,
  icon,
  iconPosition,
  loader,
  loading,
  onClick,
  size,
  rounded,
  success: success2,
  disabled,
  text,
  type,
  className,
  children
}) => /* @__PURE__ */ jsxs("button", {
  className: `
      uik-button
      ${fill ? "uik-button--fill" : ""}
      ${neomorph ? "uik-button--neomorph" : ""}
      ${danger2 ? "uik-button--danger" : ""}
      ${success2 ? "uik-button--success" : ""}
      ${size === "small" ? "uik-button--small" : ""}
      ${size === "large" ? "uik-button--large" : ""}
      ${rounded ? "uik-button--rounded" : ""}
      ${loading ? "uik-button--loading" : ""}
      ${disabled ? "uik-button--disabled" : ""}
      ${!!icon && !text && !children ? "uik-button--icon" : ""}
      ${className || ""}
    `,
  disabled: loading || disabled,
  onClick,
  type: type || "button",
  children: [loading && (loader === "fish" ? /* @__PURE__ */ jsx(FishAnimation, {}) : /* @__PURE__ */ jsx(Loading, {})), !!icon && iconPosition !== "right" && /* @__PURE__ */ jsx(Icon, {
    className: "uik-button__icon",
    icon
  }), (!!children || !!text) && /* @__PURE__ */ jsxs("span", {
    className: "uik-button__text",
    children: [children, text]
  }), !!icon && iconPosition === "right" && /* @__PURE__ */ jsx(Icon, {
    className: "uik-button__icon",
    icon
  })]
});
const Container$1 = ({
  vertical,
  className,
  children,
  flow
}) => /* @__PURE__ */ jsx("div", {
  className: `
      uik-container
      ${!!vertical ? "uik-container--vertical" : ""}
      ${flow === "start" ? "uik-container--flow-start" : ""}
      ${flow === "end" ? "uik-container--flow-end" : ""}
      ${flow === "spaceAround" ? "uik-container--flow-space-around" : ""}
      ${flow === "spaceBetween" ? "uik-container--flow-space-between" : ""}
      ${flow === "stretch" ? "uik-container--flow-stretch" : ""}
      ${className || ""}
    `,
  children
});
const Card$1 = ({
  title,
  titlePosition,
  condensed,
  head,
  children,
  className
}) => /* @__PURE__ */ jsxs("div", {
  className: `
      uik-card
      ${condensed ? "uik-card--condensed" : ""}
      ${className || ""}
    `,
  children: [(!!head || !!title) && /* @__PURE__ */ jsxs("div", {
    className: "uik-card__head",
    children: [!!title && /* @__PURE__ */ jsx("div", {
      className: `
              uik-card__title
              ${titlePosition === "center" ? "uik-card__title--center" : ""}
              ${titlePosition === "right" ? "uik-card__title--right" : ""}
            `,
      children: title
    }), head || ""]
  }), /* @__PURE__ */ jsx("div", {
    className: "uik-card__content",
    children
  })]
});
const Text = ({
  text,
  type,
  className,
  children
}) => /* @__PURE__ */ jsxs("div", {
  className: `
      uik-text
      ${type === "headline" ? "uik-text--headline" : ""}
      ${type === "title" ? "uik-text--title" : ""}
      ${type === "light" ? "uik-text--light" : ""}
      ${type === "lead" ? "uik-text--lead" : ""}
      ${type === "mini" ? "uik-text--mini" : ""}
      ${className || ""}
    `,
  children: [children, text]
});
const Divider = ({
  text,
  spacing,
  className
}) => {
  const getContentIdentifier = () => {
    if (!text)
      return "";
    const base = "uik-divider--text-";
    return base + text.toLowerCase().replaceAll(" ", "-");
  };
  return /* @__PURE__ */ jsx("div", {
    id: getContentIdentifier(),
    className: `
        uik-divider
        ${spacing === "small" ? "uik-divider--small" : ""}
        ${spacing === "large" ? "uik-divider--large" : ""}
        ${getContentIdentifier()}
        ${className || ""}
      `,
    children: !!text ? /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx("div", {
        className: "uik-divider__line"
      }), /* @__PURE__ */ jsx("div", {
        className: "uik-divider__text",
        children: text
      }), /* @__PURE__ */ jsx("div", {
        className: "uik-divider__line"
      })]
    }) : /* @__PURE__ */ jsx("div", {
      className: "uik-divider__line"
    })
  });
};
const Dropdown = ({
  isOpen,
  stayOpen,
  onClose,
  position,
  children,
  className
}) => {
  const dropdown = useRef(null);
  const getChildClick = (child) => {
    return () => {
      if (child.props.onClick)
        child.props.onClick();
      if (!stayOpen)
        onClose();
    };
  };
  const getChildren = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        onClick: getChildClick(child)
      });
    }
    return child;
  });
  return /* @__PURE__ */ jsxs("div", {
    className: `
        uik-dropdown
        ${position === "top" ? "uik-dropdown--top" : ""}
        ${position === "bottomRight" ? "uik-dropdown--bottom-right" : ""}
        ${position === "bottomLeft" ? "uik-dropdown--bottom-left" : ""}
        ${position === "topRight" ? "uik-dropdown--top-right" : ""}
        ${position === "topLeft" ? "uik-dropdown--top-left" : ""}
        ${className || ""}
      `,
    children: [/* @__PURE__ */ jsx(CSSTransition, {
      in: isOpen,
      className: "uik-dropdown__dropdown",
      nodeRef: dropdown,
      timeout: 150,
      unmountOnExit: true,
      children: /* @__PURE__ */ jsx("div", {
        ref: dropdown,
        className: "uik-dropdown__dropdown",
        children: getChildren
      })
    }), isOpen && /* @__PURE__ */ jsx("div", {
      className: "uik-dropdown__overlay",
      onClick: onClose
    })]
  });
};
const DropdownItem = ({
  text,
  icon,
  onClick,
  children,
  className
}) => /* @__PURE__ */ jsxs("button", {
  className: `
      uik-dropdown__item
      ${className || ""}
    `,
  onClick,
  type: "button",
  children: [!!icon && /* @__PURE__ */ jsx("div", {
    className: "uik-dropdown__item-icon",
    children: /* @__PURE__ */ jsx(Icon, {
      className: "uik-button__icon",
      icon
    })
  }), /* @__PURE__ */ jsxs("span", {
    className: "uik-dropdown__item-text",
    children: [children, text]
  })]
});
const Card = ({
  text,
  position,
  children,
  delay,
  className
}) => /* @__PURE__ */ jsxs("div", {
  className: `
      uik-tooltip
      ${position === "bottom" ? "uik-tooltip--bottom" : ""}
      ${position === "left" ? "uik-tooltip--left" : ""}
      ${position === "right" ? "uik-tooltip--right" : ""}
      ${className || ""}
    `,
  children: [children, /* @__PURE__ */ jsx("div", {
    className: "uik-tooltip__tooltip-wrapper",
    style: {
      "--delay": `${delay !== void 0 ? delay : 0.5}s`
    },
    children: /* @__PURE__ */ jsx("div", {
      className: "uik-tooltip__tooltip",
      children: /* @__PURE__ */ jsx("div", {
        className: "uik-tooltip__tooltip-text",
        children: text
      })
    })
  })]
});
const Modal = ({
  title,
  isOpen,
  onClose,
  onOpened,
  onClosed,
  children,
  footer,
  className
}) => {
  const modal = useRef(null);
  const overlay = useRef(null);
  return /* @__PURE__ */ jsxs("div", {
    className: `
        uik-modal
        ${className || ""}
      `,
    children: [/* @__PURE__ */ jsx(CSSTransition, {
      in: isOpen,
      className: "uik-modal__container",
      nodeRef: modal,
      timeout: 200,
      unmountOnExit: true,
      onEnter: onOpened,
      onExited: onClosed,
      children: /* @__PURE__ */ jsx("div", {
        ref: modal,
        className: "uik-modal__container",
        children: /* @__PURE__ */ jsxs("div", {
          className: "uik-modal__popup",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "uik-modal__head",
            children: [/* @__PURE__ */ jsx("div", {
              className: "uik-modal__title",
              children: title
            }), /* @__PURE__ */ jsx("button", {
              className: "uik-modal__close-btn",
              onClick: onClose,
              children: /* @__PURE__ */ jsx(Icon, {
                className: "uik-modal__close-btn-icon",
                icon: faXmark
              })
            })]
          }), /* @__PURE__ */ jsx("div", {
            className: "uik-modal__body",
            children
          }), !!footer && /* @__PURE__ */ jsx("div", {
            className: "uik-modal__footer",
            children: footer
          })]
        })
      })
    }), /* @__PURE__ */ jsx(CSSTransition, {
      in: isOpen,
      className: "uik-modal__overlay",
      nodeRef: overlay,
      timeout: 200,
      unmountOnExit: true,
      children: /* @__PURE__ */ jsx("div", {
        ref: overlay,
        className: "uik-modal__overlay",
        onClick: onClose
      })
    })]
  });
};
const Label = ({
  text,
  children,
  className
}) => /* @__PURE__ */ jsxs("label", {
  className: `
      uik-label
      ${className || ""}
    `,
  children: [text, children]
});
const Form = ({
  children,
  className
}) => /* @__PURE__ */ jsx("form", {
  className: `
      uik-form
      ${className || ""}
    `,
  children
});
const Input = ({
  value,
  defaultValue,
  type,
  label,
  placeholder,
  name,
  error,
  className,
  rows,
  textarea,
  required,
  readOnly,
  disabled,
  autoComplete,
  maxLength,
  min,
  max,
  onBlur,
  onFocus,
  onInput,
  onChange,
  onKeyPress,
  onKeyDown,
  onKeyUp
}) => {
  const InputTag = textarea ? "textarea" : "input";
  const getNumber = (str) => {
    if (!str)
      return void 0;
    if (typeof str === "number")
      return str;
    const num = parseInt(str);
    if (isNaN(num))
      return void 0;
    return num;
  };
  const [displayPassword, setDisplayPassword] = useState(false);
  const getType = () => {
    if (type === "password" && displayPassword)
      return "text";
    return type;
  };
  return /* @__PURE__ */ jsxs("div", {
    className: `
        uik-input
        ${!!error ? "uik-input--error" : ""}
        ${className || ""}
      `,
    children: [!!error && /* @__PURE__ */ jsx("div", {
      className: "uik-input__error",
      children: error
    }), /* @__PURE__ */ jsxs("div", {
      className: "uik-input__wrapper",
      children: [!!label && /* @__PURE__ */ jsxs(Label, {
        className: "uik-input__label",
        children: [label, required ? " *" : ""]
      }), /* @__PURE__ */ jsxs("div", {
        className: "uik-input__input-wrapper",
        children: [type === "password" && /* @__PURE__ */ jsx("button", {
          className: "uik-input__show-password-btn",
          type: "button",
          onMouseDown: () => setDisplayPassword(true),
          onMouseUp: () => setDisplayPassword(false),
          children: /* @__PURE__ */ jsx(Icon, {
            icon: displayPassword ? faEyeSlash : faEye
          })
        }), /* @__PURE__ */ jsx(InputTag, {
          className: "uik-input__input",
          type: getType(),
          name,
          placeholder,
          value,
          defaultValue,
          rows: getNumber(rows),
          required,
          disabled,
          readOnly,
          autoComplete: autoComplete ? "on" : "off",
          maxLength: getNumber(maxLength),
          min,
          max,
          onBlur,
          onFocus,
          onInput,
          onChange,
          onKeyPress,
          onKeyDown,
          onKeyUp
        })]
      })]
    })]
  });
};
const Toggle = ({
  value,
  label,
  onText,
  offText,
  disabled,
  onChange,
  onInput,
  onClick,
  className
}) => {
  const changeValue = (event) => {
    if (disabled)
      return;
    if (onChange)
      onChange(!value, event);
    if (onInput)
      onInput(!value, event);
    if (onClick)
      onClick(!value, event);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: `
        uik-toggle
        ${value ? "uik-toggle--active" : ""}
        ${disabled ? "uik-toggle--disabled" : ""}
        ${className || ""}
      `,
    children: [!!label && /* @__PURE__ */ jsx(Label, {
      text: label,
      className: "uik-toggle__label"
    }), /* @__PURE__ */ jsxs("button", {
      className: "uik-toggle__toggle",
      type: "button",
      onClick: changeValue,
      children: [!!onText && /* @__PURE__ */ jsx("div", {
        className: "uik-toggle__text uik-toggle__text--on",
        children: onText
      }), /* @__PURE__ */ jsx("div", {
        className: "uik-toggle__circle"
      }), !!offText && /* @__PURE__ */ jsx("div", {
        className: "uik-toggle__text uik-toggle__text--off",
        children: offText
      })]
    })]
  });
};
const Select = ({
  label,
  value,
  options,
  optionMap,
  multiple,
  disabled,
  placeholder,
  required,
  error,
  className
}) => {
  const [isOpen, setOpen] = useState(false);
  console.log(isOpen);
  const toggleOpen = (state) => {
    if (disabled)
      return;
    setOpen(state);
  };
  const getOptions = () => {
    let output = [];
    const map = {
      value: (optionMap == null ? void 0 : optionMap.value) || "value",
      text: (optionMap == null ? void 0 : optionMap.text) || "text"
    };
    if (options) {
      options.forEach((option) => {
        if (typeof option === "object") {
          output.push({
            value: option[map.value],
            text: String(option[map.text])
          });
        } else {
          output.push({
            value: option,
            text: String(option)
          });
        }
      });
    }
    return output;
  };
  const getDispayValue = () => {
    if (!value || Array.isArray(value) && !value.length)
      return "";
    const options2 = getOptions();
    const getTextByValue = (value2) => {
      var _a;
      return ((_a = options2.find((option) => option.value === value2)) == null ? void 0 : _a.text) || "";
    };
    if (multiple) {
      let output = [];
      value.forEach((item) => {
        output.push(getTextByValue(item));
      });
      return output.join(", ");
    } else {
      return getTextByValue(value);
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: `
        uik-select
        ${!!error ? "uik-select--error" : ""}
        ${className || ""}
      `,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "uik-select__wrapper",
      children: [!!label && /* @__PURE__ */ jsxs(Label, {
        className: "uik-select__label",
        children: [label, required ? " *" : ""]
      }), /* @__PURE__ */ jsxs("button", {
        className: "uik-select__field",
        type: "button",
        onClick: () => toggleOpen(true),
        disabled,
        children: [/* @__PURE__ */ jsx("span", {
          className: `
                uik-select__value
                ${!value && !!placeholder ? "uik-select__value--placeholder" : ""}
              `,
          children: getDispayValue()
        }), /* @__PURE__ */ jsx(Icon, {
          className: "uik-select__field-icon",
          icon: faCaretDown
        })]
      })]
    }), !!error && /* @__PURE__ */ jsx("div", {
      className: "uik-select__error",
      children: error
    })]
  });
};
const Celebrate = ({
  className,
  type,
  onDestroy
}) => {
  const [destroy, setDestroy] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      if (onDestroy)
        onDestroy();
      setDestroy(true);
    }, 3.5 * 1e3);
    return () => {
    };
  }, []);
  const Particle = ({
    index: index2
  }) => {
    if (type === "money") {
      return /* @__PURE__ */ jsx(Icon, {
        className: `
            uik-celebrate__particle
            uik-celebrate__particle--${index2}
          `,
        icon: faMoneyBillWave
      });
    }
    return /* @__PURE__ */ jsx("div", {
      className: `
          uik-celebrate__particle
          uik-celebrate__particle--${index2}
        `
    });
  };
  return /* @__PURE__ */ jsx("div", {
    className: `
        uik-celebrate
        uik-celebrate--${type || "confetti"}
        ${destroy ? "uik-celebrate--destroy" : ""}
        ${className || ""}
      `,
    children: (() => {
      let output = [];
      for (let i = 0; i < 150; i++) {
        output.push(/* @__PURE__ */ jsx(Particle, {
          index: i
        }, i));
      }
      return output;
    })()
  });
};
const Avatar = ({
  image,
  name,
  size,
  className
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: `
        uik-avatar
        ${size === "small" ? "uik-avatar--small" : ""}
        ${size === "large" ? "uik-avatar--large" : ""}
        ${size === "extra-large" ? "uik-avatar--extra-large" : ""}
        ${className || ""}
      `,
    title: name || "",
    children: [/* @__PURE__ */ jsx("div", {
      className: "uik-avatar__avatar",
      style: {
        backgroundImage: `url(${image || ""})`
      }
    }), !!name && /* @__PURE__ */ jsx("div", {
      className: "uik-avatar__name",
      children: name
    })]
  });
};
const ActionButton = ({
  text,
  icon,
  color,
  onClick,
  url,
  children,
  className
}) => {
  const ButtonTag = !!url ? "a" : "button";
  const getIcon2 = () => {
    if (!icon)
      return void 0;
    if (React.isValidElement(icon)) {
      return {
        ...icon,
        key: "icon"
      };
    }
    return /* @__PURE__ */ jsx(Icon, {
      className: "uik-action-button__icon",
      icon
    });
  };
  return /* @__PURE__ */ jsxs(ButtonTag, {
    className: `
        uik-action-button
        ${!!color ? "uik-action-button--" + color : ""}
        ${className || ""}
      `,
    type: ButtonTag === "button" ? "button" : void 0,
    target: ButtonTag === "a" ? "_blank" : void 0,
    href: ButtonTag === "a" ? url : void 0,
    onClick,
    children: [getIcon2(), /* @__PURE__ */ jsxs("div", {
      className: "uik-action-button__text",
      children: [text, children]
    })]
  });
};
const Tabs = ({
  value,
  options,
  onChange,
  className
}) => {
  const select = (tab) => {
    if (onChange && value !== tab)
      onChange(tab);
  };
  const getOptions = () => {
    if (!options)
      return [];
    let output = [];
    options.forEach((option) => {
      if (typeof option === "object") {
        output.push(option);
      } else {
        output.push({
          value: option,
          text: option
        });
      }
    });
    return output;
  };
  return /* @__PURE__ */ jsx("div", {
    className: `
        uik-tabs
        ${className || ""}
      `,
    children: getOptions().map((option, index2) => /* @__PURE__ */ jsxs("button", {
      className: `
              uik-tabs__tab
              ${value === option.value ? "uik-tabs__tab--selected" : ""}
              ${!!option.indicator ? "uik-tabs__tab--with-indicator" : ""}
            `,
      disabled: value === option.value,
      type: "button",
      onClick: () => select(option.value),
      children: [!!option.indicator && /* @__PURE__ */ jsx("div", {
        className: "uik-tabs__tab-indicator",
        children: option.indicator
      }), /* @__PURE__ */ jsx("span", {
        children: option.text
      })]
    }, index2))
  });
};
const Checkbox = ({
  value,
  label,
  disabled,
  onClick,
  onChange,
  onInput,
  className
}) => {
  const changeValue = (event) => {
    if (disabled)
      return;
    if (onChange)
      onChange(!value, event);
    if (onInput)
      onInput(!value, event);
    if (onClick)
      onClick(!value, event);
  };
  return /* @__PURE__ */ jsx("div", {
    className: `
        uik-checkbox
        ${value ? "uik-checkbox--checked" : ""}
        ${disabled ? "uik-checkbox--disabled" : ""}
        ${className || ""}
      `,
    children: /* @__PURE__ */ jsxs("button", {
      className: "uik-checkbox__wrapper",
      type: "button",
      onClick: changeValue,
      children: [/* @__PURE__ */ jsx("div", {
        className: "uik-checkbox__checkbox",
        children: value && /* @__PURE__ */ jsx("div", {
          className: "uik-checkbox__check-icon"
        })
      }), !!label && /* @__PURE__ */ jsx("div", {
        className: "uik-checkbox__label",
        children: label
      })]
    })
  });
};
const Radio = ({
  value,
  label,
  disabled,
  onClick,
  onSelect,
  className
}) => {
  const select = (event) => {
    if (disabled)
      return;
    if (onSelect)
      onSelect(!value, event);
    if (onClick)
      onClick(!value, event);
  };
  return /* @__PURE__ */ jsx("div", {
    className: `
        uik-radio
        ${value ? "uik-radio--selected" : ""}
        ${disabled ? "uik-radio--disabled" : ""}
        ${className || ""}
      `,
    children: /* @__PURE__ */ jsxs("button", {
      className: "uik-radio__wrapper",
      type: "button",
      onClick: select,
      children: [/* @__PURE__ */ jsx("div", {
        className: "uik-radio__radio"
      }), !!label && /* @__PURE__ */ jsx("div", {
        className: "uik-radio__label",
        children: label
      })]
    })
  });
};
const QRCode = ({
  value,
  className
}) => /* @__PURE__ */ jsx("div", {
  className: `
      uik-qr-code
      ${className || ""}
    `,
  children: /* @__PURE__ */ jsx(QRCodeSVG, {
    value
  })
});
var theme = {
  "hljs": {
    "display": "block",
    "overflowX": "auto",
    "padding": "0.5em",
    "color": "#abb2bf",
    "background": "#282c34"
  },
  "hljs-keyword": {
    "color": "#F92672"
  },
  "hljs-operator": {
    "color": "#F92672"
  },
  "hljs-pattern-match": {
    "color": "#F92672"
  },
  "hljs-pattern-match .hljs-constructor": {
    "color": "#61aeee"
  },
  "hljs-function": {
    "color": "#61aeee"
  },
  "hljs-function .hljs-params": {
    "color": "#A6E22E"
  },
  "hljs-function .hljs-params .hljs-typing": {
    "color": "#FD971F"
  },
  "hljs-module-access .hljs-module": {
    "color": "#7e57c2"
  },
  "hljs-constructor": {
    "color": "#e2b93d"
  },
  "hljs-constructor .hljs-string": {
    "color": "#9CCC65"
  },
  "hljs-comment": {
    "color": "#b18eb1",
    "fontStyle": "italic"
  },
  "hljs-quote": {
    "color": "#b18eb1",
    "fontStyle": "italic"
  },
  "hljs-doctag": {
    "color": "#c678dd"
  },
  "hljs-formula": {
    "color": "#c678dd"
  },
  "hljs-section": {
    "color": "#e06c75"
  },
  "hljs-name": {
    "color": "#e06c75"
  },
  "hljs-selector-tag": {
    "color": "#e06c75"
  },
  "hljs-deletion": {
    "color": "#e06c75"
  },
  "hljs-subst": {
    "color": "#e06c75"
  },
  "hljs-literal": {
    "color": "#56b6c2"
  },
  "hljs-string": {
    "color": "#98c379"
  },
  "hljs-regexp": {
    "color": "#98c379"
  },
  "hljs-addition": {
    "color": "#98c379"
  },
  "hljs-attribute": {
    "color": "#98c379"
  },
  "hljs-meta-string": {
    "color": "#98c379"
  },
  "hljs-built_in": {
    "color": "#e6c07b"
  },
  "hljs-class .hljs-title": {
    "color": "#e6c07b"
  },
  "hljs-attr": {
    "color": "#d19a66"
  },
  "hljs-variable": {
    "color": "#d19a66"
  },
  "hljs-template-variable": {
    "color": "#d19a66"
  },
  "hljs-type": {
    "color": "#d19a66"
  },
  "hljs-selector-class": {
    "color": "#d19a66"
  },
  "hljs-selector-attr": {
    "color": "#d19a66"
  },
  "hljs-selector-pseudo": {
    "color": "#d19a66"
  },
  "hljs-number": {
    "color": "#d19a66"
  },
  "hljs-symbol": {
    "color": "#61aeee"
  },
  "hljs-bullet": {
    "color": "#61aeee"
  },
  "hljs-link": {
    "color": "#61aeee",
    "textDecoration": "underline"
  },
  "hljs-meta": {
    "color": "#61aeee"
  },
  "hljs-selector-id": {
    "color": "#61aeee"
  },
  "hljs-title": {
    "color": "#61aeee"
  },
  "hljs-emphasis": {
    "fontStyle": "italic"
  },
  "hljs-strong": {
    "fontWeight": "bold"
  }
};
const Notifications = ({
  notifications: notifications2,
  onClose
}) => {
  const closeNotification = (id) => {
    if (onClose) {
      onClose(id);
    }
  };
  return /* @__PURE__ */ jsx("div", {
    className: "uik-notifications",
    children: notifications2.map((notification) => /* @__PURE__ */ jsx(Alert, {
      type: notification.type,
      text: notification.message,
      onClose: () => closeNotification(notification.id),
      aliveFor: notification.keepAlive ? void 0 : notification.aliveFor || 4,
      children: notification.children
    }, notification.id))
  });
};
class Container {
  constructor(id) {
    __publicField(this, "id");
    __publicField(this, "root");
    __publicField(this, "getElement", () => {
      return document.getElementById(this.id);
    });
    __publicField(this, "create", () => {
      let el = this.getElement();
      if (!el) {
        el = document.createElement("div");
        el.id = this.id;
        document.body.appendChild(el);
      }
      this.root = el;
    });
    __publicField(this, "render", (children) => {
      if (!this.root)
        this.create();
      if (this.root)
        ReactDOM.render(children, this.root);
    });
    __publicField(this, "destroy", () => {
      if (!this.root)
        return;
      this.root.remove();
      this.root = null;
    });
    this.id = id;
    this.root = null;
  }
}
let notifications = [];
const generateId = () => {
  let id = Math.floor(Math.random() * 1e6);
  const isUnique = (() => {
    return !notifications.find((item) => item.id === id);
  })();
  if (!isUnique)
    id = generateId();
  return id;
};
const add = ({
  type,
  params
}) => {
  const id = generateId();
  if (typeof params === "string") {
    params = {
      message: params
    };
  }
  notifications.push({
    id,
    type,
    ...params
  });
  render();
};
const remove = (id) => {
  setTimeout(() => {
    const notification = notifications.find((notification2) => notification2.id === id);
    if (notification) {
      const index2 = notifications.indexOf(notification);
      notifications.splice(index2, 1);
      render();
    }
  }, 0.25 * 1e3);
};
const container$1 = new Container("uik-notifications-container");
const render = () => {
  if (!notifications.length) {
    container$1.destroy();
    return;
  }
  container$1.render(/* @__PURE__ */ jsx(Notifications, {
    notifications,
    onClose: remove
  }));
};
const info = (params) => {
  add({
    type: "info",
    params
  });
};
const success = (params) => {
  add({
    type: "success",
    params
  });
};
const danger = (params) => {
  add({
    type: "danger",
    params
  });
};
const notify = {
  info,
  success,
  danger
};
const CopyButton = ({
  value,
  tooltip,
  notification,
  onClick,
  className
}) => {
  const showNotification = () => {
    let type = "info";
    let content = notification;
    if (typeof notification === "object" && !!notification.type) {
      type = notification.type;
      content = {
        ...notification
      };
      delete content.type;
    }
    notify[type](content);
  };
  const copy = (event) => {
    if (onClick)
      onClick(event);
    if (!value)
      return;
    navigator.clipboard.writeText(value).then(() => {
      if (!!notification)
        showNotification();
    }, () => {
      notify.danger("Cannot copy to clipboard");
    });
  };
  const Wrapper = ({
    children
  }) => {
    if (!tooltip)
      return /* @__PURE__ */ jsx(Fragment, {
        children
      });
    return /* @__PURE__ */ jsx(Card, {
      text: tooltip,
      className: className || "",
      children
    });
  };
  return /* @__PURE__ */ jsx(Wrapper, {
    children: /* @__PURE__ */ jsx("button", {
      className: `
          uik-copy-button
          ${!tooltip ? className || "" : ""}
        `,
      type: "button",
      onClick: copy,
      children: /* @__PURE__ */ jsx(Icon, {
        icon: faClone
      })
    })
  });
};
const Code = ({
  code,
  children,
  lang,
  className
}) => {
  const content = code || children;
  return /* @__PURE__ */ jsxs("div", {
    className: `
        uik-code
        ${className || ""}
      `,
    children: [!!content && /* @__PURE__ */ jsx(CopyButton, {
      className: "uik-code__copy-btn",
      value: content,
      notification: "Copied to clipboard",
      tooltip: "Copy code"
    }), /* @__PURE__ */ jsx(SyntaxHighlighter, {
      language: lang || "javascript",
      wrapLongLines: true,
      style: theme,
      children: content
    })]
  });
};
const Paginate = ({
  current,
  count,
  onChange,
  className
}) => {
  const getPages = () => {
    if (count === 2)
      return [1, 2];
    if (count > 2) {
      if (current === 1)
        return [1, 2, 3];
      if (current === count)
        return [count - 2, count - 1, count];
      return [current - 1, current, current + 1];
    }
    return [];
  };
  return /* @__PURE__ */ jsx(Fragment, {
    children: count > 1 && /* @__PURE__ */ jsx("div", {
      className: `
            uik-paginate
            ${className || ""}
          `,
      children: /* @__PURE__ */ jsxs("div", {
        className: "uik-paginate__wrapper",
        children: [count > 3 && current > 2 && /* @__PURE__ */ jsxs("button", {
          className: "uik-paginate__first",
          onClick: () => onChange(1),
          children: [/* @__PURE__ */ jsx(Icon, {
            icon: faChevronLeft
          }), /* @__PURE__ */ jsx(Icon, {
            icon: faChevronLeft
          })]
        }), current > 1 && /* @__PURE__ */ jsx("button", {
          className: "uik-paginate__prev",
          onClick: () => onChange(current - 1),
          children: /* @__PURE__ */ jsx(Icon, {
            icon: faChevronLeft
          })
        }), getPages().map((page, index2) => /* @__PURE__ */ jsx("button", {
          className: `
                    uik-paginate__page
                    ${page === current ? "uik-paginate__page--current" : ""}
                  `,
          onClick: () => onChange(page),
          children: /* @__PURE__ */ jsx("span", {
            children: page
          })
        }, `${page}-${index2}`)), current < count && /* @__PURE__ */ jsx("button", {
          className: "uik-paginate__next",
          onClick: () => onChange(current + 1),
          children: /* @__PURE__ */ jsx(Icon, {
            icon: faChevronLeft
          })
        }), count > 3 && current < count - 1 && /* @__PURE__ */ jsxs("button", {
          className: "uik-paginate__last",
          onClick: () => onChange(count),
          children: [/* @__PURE__ */ jsx(Icon, {
            icon: faChevronLeft
          }), /* @__PURE__ */ jsx(Icon, {
            icon: faChevronLeft
          })]
        })]
      })
    })
  });
};
const Table = ({
  children,
  className,
  seamless,
  height,
  pagination
}) => {
  const getHeight = () => {
    if (height)
      return {
        maxHeight: `${height}px`
      };
    return {};
  };
  return /* @__PURE__ */ jsxs("div", {
    className: `
        uik-table
        ${seamless ? "uik-table--seamless" : ""}
        ${className || ""}
      `,
    children: [/* @__PURE__ */ jsx("div", {
      className: "uik-table__wrapper",
      style: getHeight(),
      children: /* @__PURE__ */ jsx("table", {
        className: "uik-table__table",
        children
      })
    }), !!pagination && /* @__PURE__ */ jsx(Paginate, {
      current: pagination.current,
      count: pagination.count,
      onChange: pagination.onChange
    })]
  });
};
const THead = ({
  children,
  className
}) => /* @__PURE__ */ jsx("thead", {
  className: `
      uik-table-head
      ${className || ""}
    `,
  children
});
const TBody = ({
  children,
  className
}) => /* @__PURE__ */ jsx("tbody", {
  className: `
      uik-table-body
      ${className || ""}
    `,
  children
});
const Tr = ({
  onClick,
  children,
  className
}) => /* @__PURE__ */ jsx("tr", {
  className: `
      uik-table-row
      ${!!onClick ? "uik-table-row--clickable" : ""}
      ${className || ""}
    `,
  onClick,
  children
});
const Th = ({
  align,
  children,
  width,
  className
}) => {
  const getWidth = () => {
    if (width)
      return {
        width: `${width}px`
      };
    return {};
  };
  return /* @__PURE__ */ jsx("th", {
    style: getWidth(),
    className: `
        uik-table-head-cell
        ${align ? `uik-table-head-cell--${align}` : ""}
        ${className || ""}
      `,
    children: /* @__PURE__ */ jsx("div", {
      className: "uik-table-head-cell__content",
      children
    })
  });
};
const Td = ({
  align,
  children,
  className
}) => /* @__PURE__ */ jsx("td", {
  className: `
      uik-table-cell
      ${align ? `uik-table-cell--${align}` : ""}
      ${className || ""}
    `,
  children: /* @__PURE__ */ jsx("div", {
    className: "uik-table-cell__content",
    children
  })
});
const Tag = ({
  text,
  color,
  children,
  className
}) => /* @__PURE__ */ jsx("div", {
  className: `
      uik-tag
      ${!!color ? "uik-tag--" + color : ""}
      ${className || ""}
    `,
  children: /* @__PURE__ */ jsxs("span", {
    children: [text, children]
  })
});
const Trend = ({
  type = "good",
  direction = "up",
  text,
  children,
  className
}) => /* @__PURE__ */ jsxs("div", {
  className: `
      uik-trend
      uik-trend--${type}
      uik-trend--${direction}
      ${className || ""}
    `,
  children: [/* @__PURE__ */ jsx("div", {
    className: "uik-trend__arrow"
  }), !!text && /* @__PURE__ */ jsxs("span", {
    className: "uik-trend__content",
    children: [text, children]
  })]
});
const formatAddress = (address = "", offset = 5) => {
  if (address.length > offset) {
    return `${address.slice(0, offset)}...${address.slice(address.length - offset)}`;
  }
  return address;
};
const formatAmount = (amount) => {
  if (!amount)
    return "";
  const parts = amount.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const output = parts.join(".");
  return output;
};
const maxDecimals = (num, decPlaces = 2, method = "round") => {
  if (typeof num !== "number")
    num = new BigNumber(num).toNumber();
  const decFactor = 10 ** decPlaces;
  return Math[method]((num + Number.EPSILON) * decFactor) / decFactor;
};
const formatHumanAmount = (amount, decPlaces = 2) => {
  if (typeof amount === "string") {
    amount = amount.replaceAll(",", "");
    amount = new BigNumber(amount).toNumber();
  }
  if (isNaN(amount))
    return String(amount);
  decPlaces = Math.pow(10, decPlaces);
  const abbrev = ["k", "M", "B"];
  for (let i = abbrev.length - 1; i >= 0; i--) {
    const size = Math.pow(10, (i + 1) * 3);
    if (size <= amount) {
      amount = Math.round(amount * decPlaces / size) / decPlaces;
      if (amount === 1e3 && i < abbrev.length - 1) {
        amount = 1;
        i++;
      }
      amount = `${amount} ${abbrev[i]}`;
      break;
    }
  }
  return String(amount);
};
const Amount = ({
  value,
  className,
  children
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: `
        uik-reef-amount
        ${className || ""}
      `,
    children: [(!!value || !!children) && /* @__PURE__ */ jsx(ReefIcon, {}), /* @__PURE__ */ jsxs("span", {
      className: "uik-reef-amount__value",
      children: [children, formatAmount(value)]
    })]
  });
};
const Slider = ({
  value,
  steps = 1,
  helpers,
  stickyHelpers = true,
  tooltip,
  disabled,
  className,
  onChange
}) => {
  const [dragging, setDragging] = useState(false);
  const sliderEl = useRef(null);
  const getValue = () => {
    if (value > 100)
      return 100;
    if (value < 0)
      return 0;
    return value;
  };
  const handleMouseDown = (event) => {
    changePostion(event);
    const handleMouseMove = (event2) => {
      changePostion(event2);
      setDragging(true);
    };
    const handleMouseUp = (event2) => {
      changePostion(event2);
      setDragging(false);
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };
  const changePostion = (event) => {
    if (disabled || !onChange)
      return;
    const container2 = sliderEl.current;
    if (!container2)
      return;
    const containerDim = container2.getBoundingClientRect();
    const width = containerDim.width;
    const pxPos = event.clientX - containerDim.left;
    let position = Math.round(pxPos * 100 / width);
    if (position < 0)
      position = 0;
    if (position > 100)
      position = 100;
    if (steps) {
      position = Math.round(position / steps) * steps;
    }
    if (stickyHelpers) {
      const closestHelper = (() => {
        const helperDiffs = helpers.map((helper, index2) => {
          let diff = helper.position - position;
          if (diff < 0)
            diff *= -1;
          return {
            index: index2,
            diff
          };
        }).sort((a, b) => {
          const posA = a.diff;
          const posB = b.diff;
          if (posA > posB)
            return 1;
          if (posA < posB)
            return -1;
          return 0;
        });
        const closestHelper2 = helperDiffs[0];
        return {
          ...helpers[closestHelper2.index],
          ...closestHelper2
        };
      })();
      const stickyThreshold = 3;
      if (closestHelper.diff < stickyThreshold) {
        position = closestHelper.position;
      }
    }
    onChange(position);
  };
  const setPosition = (position) => {
    onChange(position);
  };
  return /* @__PURE__ */ jsx("div", {
    ref: sliderEl,
    className: `
        uik-slider
        ${disabled ? "uik-slider--disabled" : ""}
        ${dragging ? "uik-slider--dragging" : ""}
        ${className || ""}
      `,
    children: /* @__PURE__ */ jsxs("button", {
      className: "uik-slider__slider",
      style: {
        "--position": `${getValue()}`
      },
      onClick: changePostion,
      onMouseDown: handleMouseDown,
      children: [/* @__PURE__ */ jsx("div", {
        className: "uik-slider__line",
        children: /* @__PURE__ */ jsx("div", {
          className: "uik-slider__line-indicator"
        })
      }), !!(helpers == null ? void 0 : helpers.length) && /* @__PURE__ */ jsx("div", {
        className: "uik-slider__helpers",
        children: helpers.map((helper) => /* @__PURE__ */ jsxs("button", {
          type: "button",
          className: `
                    uik-slider__helper
                    ${helper.position <= getValue() ? "uik-slider__helper--passed" : ""}
                  `,
          style: {
            "--position": `${helper.position}`
          },
          onMouseDown: (event) => event.stopPropagation(),
          onClick: (event) => {
            event.stopPropagation();
            setPosition(helper.position);
          },
          children: [helper.position <= getValue() && /* @__PURE__ */ jsx("div", {
            className: "uik-slider__helper-color",
            style: {
              "--opacity": `${helper.position * 100 / getValue() / 100}`
            }
          }), !!helper.text && /* @__PURE__ */ jsx("div", {
            className: "uik-slider__helper-text",
            style: {
              "--align": (() => {
                if (helper.position <= 5)
                  return "flex-start";
                if (helper.position >= 95)
                  return "flex-end";
                return "center";
              })()
            },
            children: helper.text
          })]
        }, `helper-${helper.position}`))
      }), /* @__PURE__ */ jsx("div", {
        className: "uik-slider__indicator",
        children: !!tooltip && /* @__PURE__ */ jsx("div", {
          className: "uik-slider__tooltip",
          children: tooltip
        })
      })]
    })
  });
};
const atoms = {
  Alert,
  Button,
  Container: Container$1,
  Card: Card$1,
  Icon,
  Loading,
  Text,
  Divider,
  Dropdown,
  DropdownItem,
  Tooltip: Card,
  Modal,
  Label,
  Form,
  Input,
  Toggle,
  Select,
  Celebrate,
  Avatar,
  ActionButton,
  Tabs,
  Checkbox,
  Radio,
  QRCode,
  Code,
  Table,
  THead,
  TBody,
  Tr,
  Th,
  Td,
  Tag,
  Paginate,
  Trend,
  ReefAmount: Amount,
  Slider
};
const molecules = {
  Notifications
};
const Account = ({
  name,
  address,
  evmAddress,
  source,
  isSelected,
  onSelect,
  className
}) => /* @__PURE__ */ jsxs("button", {
  className: `
      uik-account-selector-account
      ${isSelected ? "uik-account-selector-account--selected" : ""}
      ${className || ""}
    `,
  type: "button",
  onClick: onSelect,
  children: [/* @__PURE__ */ jsx(Identicon, {
    value: address,
    className: "uik-account-selector-account__identicon",
    size: 86
  }), /* @__PURE__ */ jsxs("div", {
    className: "uik-account-selector-account__info",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "uik-account-selector-account__name",
      children: [/* @__PURE__ */ jsx("span", {
        children: name
      }), !!source && source !== "reef" && /* @__PURE__ */ jsx("span", {
        className: "uik-account-selector-account__source",
        children: source
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "uik-account-selector-account__address",
      children: [/* @__PURE__ */ jsxs("div", {
        children: ["Native address: ", formatAddress(address)]
      }), /* @__PURE__ */ jsx(CopyButton, {
        value: address,
        tooltip: "Copy Reef account address to clipboard",
        notification: "Copied Reef Account Address to clipboard.",
        onClick: (e) => e.stopPropagation()
      })]
    }), !!evmAddress && /* @__PURE__ */ jsxs("div", {
      className: "uik-account-selector-account__address",
      children: [/* @__PURE__ */ jsxs("div", {
        children: ["Reef EVM address: ", formatAddress(evmAddress)]
      }), /* @__PURE__ */ jsx(CopyButton, {
        value: evmAddress,
        tooltip: "Copy Reef EVM address to clipboard",
        notification: {
          keepAlive: true,
          type: "danger",
          message: "Copied Reef EVM address to clipboard.\nDO NOT use this Reef EVM address on any other chain. ONLY use it on Reef chain.",
          children: /* @__PURE__ */ jsx(Button, {
            text: "I understand"
          })
        },
        onClick: (e) => e.stopPropagation()
      })]
    }), /* @__PURE__ */ jsx("a", {
      className: "uik-account-selector-account__open-btn",
      href: `https://reefscan.com/account/${address}`,
      target: "_blank",
      rel: "noreferrer",
      onClick: (e) => e.stopPropagation(),
      children: "Open in Explorer"
    })]
  }), /* @__PURE__ */ jsx("button", {
    type: "button",
    className: "uik-account-selector-account__qr-code",
    children: /* @__PURE__ */ jsx(QRCode, {
      value: address
    })
  }), isSelected && /* @__PURE__ */ jsx("div", {
    className: "uik-account-selector-account__selected-tag",
    children: "Selected"
  })]
});
const AccountSelector = ({
  isOpen,
  accounts,
  selectedAccount,
  selectedNetwork,
  onClose,
  onSelect,
  onNetworkSelect,
  className
}) => {
  const wrapper = useRef(null);
  const isSelected = (account) => {
    return !!(selectedAccount == null ? void 0 : selectedAccount.address) && account.address === selectedAccount.address && account.source === selectedAccount.source;
  };
  const select = (account) => {
    if (onSelect)
      onSelect(account);
  };
  const opened = () => document.body.style.overflow = "hidden";
  const closed = () => document.body.style.overflow = "";
  return /* @__PURE__ */ jsx("div", {
    className: `
        uik-account-selector
        ${className || ""}
      `,
    children: /* @__PURE__ */ jsx(CSSTransition, {
      in: isOpen,
      className: "uik-account-selector__wrapper",
      nodeRef: wrapper,
      timeout: 500,
      unmountOnExit: true,
      onEnter: opened,
      onExited: closed,
      children: /* @__PURE__ */ jsx("div", {
        ref: wrapper,
        className: "uik-account-selector__wrapper",
        children: /* @__PURE__ */ jsxs("div", {
          className: "uik-account-selector__content",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "uik-account-selector__head",
            children: [/* @__PURE__ */ jsx("div", {
              className: "uik-account-selector__title",
              children: "Select Account"
            }), !!selectedNetwork && !!onNetworkSelect && /* @__PURE__ */ jsx(Tabs, {
              className: "uik-account-selector__network",
              value: selectedNetwork,
              options: [{
                value: "mainnet",
                text: "Mainnet"
              }, {
                value: "testnet",
                text: "Testnet"
              }],
              onChange: onNetworkSelect
            }), /* @__PURE__ */ jsx("button", {
              className: "uik-account-selector__close-btn",
              type: "button",
              onClick: onClose,
              children: /* @__PURE__ */ jsx(Icon, {
                className: "uik-account-selector__close-btn-icon",
                icon: faXmark
              })
            })]
          }), /* @__PURE__ */ jsx("div", {
            className: "uik-account-selector__accounts",
            children: !!accounts && !!accounts.length && accounts.map((account, index2) => /* @__PURE__ */ jsx(Account, {
              className: "uik-account-selector__account",
              name: account.name,
              address: account.address,
              evmAddress: account.evmAddress,
              source: account.source,
              onSelect: () => select(account),
              isSelected: isSelected(account)
            }, index2))
          })]
        })
      })
    })
  });
};
const TokenComponent = ({
  image,
  symbol,
  value,
  price,
  max,
  onInput,
  onBlur,
  inputRef
}) => {
  const [isFocused, setFocused] = useState(false);
  const onInputFocus = () => setFocused(true);
  const onInputBlur = (e) => {
    setFocused(false);
    if (onBlur)
      onBlur(e);
  };
  const getPrice = useMemo(() => {
    return maxDecimals(new BigNumber$1(value || 0).times(price || 0).toNumber(), 2);
  }, [value, price]);
  return /* @__PURE__ */ jsxs("div", {
    className: `
        uik-pool-actions-token
        ${isFocused ? "uik-pool-actions-token--focused" : isFocused}
      `,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "uik-pool-actions-token__token",
      children: [/* @__PURE__ */ jsx("div", {
        className: "uik-pool-actions-token__image",
        style: {
          backgroundImage: `url(${image})`
        }
      }), /* @__PURE__ */ jsxs("div", {
        className: "uik-pool-actions-token__info",
        children: [/* @__PURE__ */ jsx("div", {
          className: "uik-pool-actions-token__symbol",
          children: symbol
        }), !!max && /* @__PURE__ */ jsxs("div", {
          className: "uik-pool-actions-token__amount",
          children: ["Available ", !!max ? formatAmount(max) : ""]
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "uik-pool-actions-token__value",
      children: [!!price && /* @__PURE__ */ jsxs("div", {
        className: `
              uik-pool-actions-token__price
              ${!getPrice ? "uik-pool-actions-token__price--empty" : ""}
            `,
        children: ["$", getPrice ? formatAmount(getPrice) : "0.0"]
      }), /* @__PURE__ */ jsx("input", {
        ref: inputRef,
        onInput,
        onBlur: onInputBlur,
        onFocus: onInputFocus,
        size: 1,
        placeholder: "0.0"
      })]
    })]
  });
};
const setInputValue = (ref, value) => {
  const el = ref.current;
  if (!el)
    return;
  let currentValue = new BigNumber(el.value).toNumber();
  if (isNaN(currentValue))
    currentValue = 0;
  if (document.activeElement === el && currentValue === value)
    return;
  let newValue = formatAmount(value).replaceAll(",", " ");
  ref.current.value = newValue;
};
const getOtherTokenKey = (key) => {
  return key === "firstToken" ? "secondToken" : "firstToken";
};
const Provide = ({
  data,
  onInput,
  onConfirm,
  calcValues = () => {
  }
}) => {
  const defaultValues = {
    firstToken: 0,
    secondToken: 0,
    percentage: 0,
    value: 0
  };
  const [values, setValues] = useState(defaultValues);
  const firstTokenInput = useRef(null);
  const secondTokenInput = useRef(null);
  const getOutput = (value = values) => {
    return {
      firstToken: {
        data: data.firstToken,
        amount: value.firstToken
      },
      secondToken: {
        data: data.secondToken,
        amount: value.secondToken
      },
      percentage: value.percentage,
      value: value.value
    };
  };
  const setValue = (value) => {
    const newValues = calcValues ? calcValues(value) : defaultValues;
    setInputValue(firstTokenInput, newValues.firstToken);
    setInputValue(secondTokenInput, newValues.secondToken);
    setValues(newValues);
    return newValues;
  };
  const handleInput = (tokenKey, event) => {
    const token = data[tokenKey];
    let value = new BigNumber(event.target.value.replace(/[^0-9.]+/gi, "")).toNumber();
    value = maxDecimals(value, 4, "floor");
    if (isNaN(value) || value < 0)
      value = 0;
    const newValues = setValue({
      [tokenKey]: value
    });
    if (onInput)
      onInput({
        token,
        data: getOutput(newValues),
        event
      });
  };
  const handleSlide = (percentage) => {
    const newValues = setValue({
      percentage
    });
    if (onInput)
      onInput({
        token: void 0,
        data: getOutput(newValues),
        event: "slide"
      });
  };
  const confirm = () => {
    if (onConfirm)
      onConfirm(getOutput());
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "uik-pool-actions__tokens",
      children: [/* @__PURE__ */ jsx(TokenComponent, {
        name: data.firstToken.name,
        symbol: data.firstToken.symbol,
        image: data.firstToken.image,
        max: data.firstToken.available,
        onInput: (e) => handleInput("firstToken", e),
        onBlur: (e) => setInputValue(firstTokenInput, values.firstToken),
        inputRef: firstTokenInput
      }), /* @__PURE__ */ jsx(TokenComponent, {
        name: data.secondToken.name,
        symbol: data.secondToken.symbol,
        image: data.secondToken.image,
        max: data.secondToken.available,
        onInput: (e) => handleInput("secondToken", e),
        onBlur: (e) => setInputValue(secondTokenInput, values.secondToken),
        inputRef: secondTokenInput
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "uik-pool-actions__summary",
      children: /* @__PURE__ */ jsxs("div", {
        className: `
            uik-pool-actions__summary-item
            ${!values.value ? "uik-pool-actions__summary-item--empty" : ""}
          `,
        children: [/* @__PURE__ */ jsx("div", {
          className: "uik-pool-actions__summary-item-label",
          children: "Total"
        }), /* @__PURE__ */ jsxs("div", {
          className: "uik-pool-actions__summary-item-value",
          children: ["$", values.value ? formatAmount(values.value) : "0.0"]
        })]
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "uik-pool-actions__slider",
      children: /* @__PURE__ */ jsx(Slider, {
        value: values.percentage,
        onChange: handleSlide,
        tooltip: `${maxDecimals(values.percentage, 2)}%`,
        helpers: [{
          position: 0,
          text: "0%"
        }, {
          position: 25
        }, {
          position: 50,
          text: "50%"
        }, {
          position: 75
        }, {
          position: 100,
          text: "100%"
        }]
      })
    }), /* @__PURE__ */ jsx(Button, {
      className: "uik-pool-actions__cta",
      fill: true,
      icon: faCoins,
      text: "Provide",
      size: "large",
      disabled: !values.firstToken || !values.secondToken || !values.percentage,
      onClick: confirm
    })]
  });
};
const Withdraw = ({
  data,
  onInput,
  onConfirm,
  calcValues = () => {
  }
}) => {
  const [percentage, setPercentage] = useState(50);
  const handleSlide = (value) => {
    setPercentage(value);
    if (onInput)
      onInput({
        percentage: value
      });
  };
  const getValues = useMemo(() => {
    const defaultValues = {
      value: 0,
      firstToken: 0,
      secondToken: 0
    };
    if (!calcValues)
      return defaultValues;
    return calcValues({
      percentage
    }) || defaultValues;
  }, [percentage]);
  const confirm = () => {
    if (onConfirm)
      onConfirm({
        percentage
      });
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: `
          uik-pool-actions__withdraw-preview
          ${!getValues.value ? "uik-pool-actions__withdraw-preview--empty" : ""}
        `,
      children: [/* @__PURE__ */ jsxs("div", {
        className: "uik-pool-actions__withdraw-percentage",
        children: [/* @__PURE__ */ jsx("span", {
          className: "uik-pool-actions__withdraw-percentage-value",
          children: percentage
        }), /* @__PURE__ */ jsx("span", {
          className: "uik-pool-actions__withdraw-percentage-sign",
          children: "%"
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "uik-pool-actions__withdraw-value",
        children: ["$", getValues.value ? formatAmount(getValues.value) : "0.0"]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "uik-pool-actions__summary",
      children: [/* @__PURE__ */ jsxs("div", {
        className: `
            uik-pool-actions__summary-item
            ${!getValues.firstToken ? "uik-pool-actions__summary-item--empty" : ""}
          `,
        children: [/* @__PURE__ */ jsx("div", {
          className: "uik-pool-actions__summary-item-label",
          children: data.firstToken.symbol
        }), /* @__PURE__ */ jsx("div", {
          className: "uik-pool-actions__summary-item-value",
          children: getValues.firstToken
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: `
            uik-pool-actions__summary-item
            ${!getValues.secondToken ? "uik-pool-actions__summary-item--empty" : ""}
          `,
        children: [/* @__PURE__ */ jsx("div", {
          className: "uik-pool-actions__summary-item-label",
          children: data.secondToken.symbol
        }), /* @__PURE__ */ jsx("div", {
          className: "uik-pool-actions__summary-item-value",
          children: getValues.secondToken
        })]
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "uik-pool-actions__slider",
      children: /* @__PURE__ */ jsx(Slider, {
        value: percentage,
        onChange: handleSlide,
        stickyHelpers: false,
        helpers: [{
          position: 0,
          text: "0%"
        }, {
          position: 25
        }, {
          position: 50,
          text: "50%"
        }, {
          position: 75
        }, {
          position: 100,
          text: "100%"
        }]
      })
    }), /* @__PURE__ */ jsx(Button, {
      className: "uik-pool-actions__cta",
      fill: true,
      icon: faArrowUpFromBracket,
      text: "Withdraw",
      size: "large",
      disabled: !percentage,
      onClick: confirm
    })]
  });
};
const SummaryItem = ({
  label,
  value,
  empty,
  className
}) => /* @__PURE__ */ jsxs("div", {
  className: `
      uik-pool-actions__summary-item
      ${empty ? "uik-pool-actions__summary-item--empty" : ""}
      ${className || ""}
    `,
  children: [/* @__PURE__ */ jsx("div", {
    className: "uik-pool-actions__summary-item-label",
    children: label
  }), /* @__PURE__ */ jsx("div", {
    className: "uik-pool-actions__summary-item-value",
    children: value
  })]
});
const Trade = ({
  data,
  onInput,
  onConfirm,
  onSwitchTokens
}) => {
  const [values, setValues] = useState({
    percentage: 0,
    firstToken: 0,
    secondToken: 0
  });
  const hasValue = useMemo(() => {
    return !!values.firstToken && !!values.secondToken && !!values.percentage;
  }, [values.firstToken, values.secondToken, values.percentage]);
  const [fromTokenKey, setFromTokenKey] = useState("firstToken");
  const toTokenKey = useMemo(() => {
    if (fromTokenKey === "firstToken")
      return "secondToken";
    return "firstToken";
  }, [fromTokenKey, data.firstToken, data.secondToken]);
  const switchTokens = () => {
    if (onSwitchTokens) {
      onSwitchTokens({
        from: data[toTokenKey],
        to: data[fromTokenKey]
      });
    }
    setFromTokenKey(toTokenKey);
    setValue({
      percentage: 0
    });
  };
  const firstTokenInput = useRef(null);
  const secondTokenInput = useRef(null);
  const tokenInputs = {
    firstToken: firstTokenInput,
    secondToken: secondTokenInput
  };
  const getRates = useMemo(() => {
    const getRatio = (tokenKey) => {
      const _token = data[tokenKey];
      const otherTokenKey = getOtherTokenKey(tokenKey);
      const token = data[otherTokenKey];
      let amount = new BigNumber(_token.price).dividedBy(token.price).toNumber();
      amount = maxDecimals(amount, 4);
      const text = `1 ${_token.symbol} = ${amount ? formatAmount(amount) : "0.0"} ${token.symbol}`;
      return {
        amount,
        text,
        _token,
        token
      };
    };
    const from = getRatio(fromTokenKey);
    const to = getRatio(toTokenKey);
    return {
      from,
      to
    };
  }, [fromTokenKey, toTokenKey, data[fromTokenKey], data[toTokenKey]]);
  const getFee = useMemo(() => {
    const token = data[fromTokenKey];
    const percentage = hasValue ? 0.3 : 0;
    let amount = new BigNumber(values[fromTokenKey]).times(new BigNumber(percentage).dividedBy(100).toNumber()).toNumber();
    amount = maxDecimals(amount, 4);
    let value = new BigNumber(amount).times(token.price).toNumber();
    value = maxDecimals(value, 2);
    const text = `$${value ? formatAmount(value) : "0.0"} (${amount ? formatAmount(amount).replaceAll(",", " ") : "0"} ${token.symbol})`;
    return {
      percentage,
      amount,
      value,
      token,
      text
    };
  }, [fromTokenKey, hasValue, values[fromTokenKey]]);
  const getSlippage = useMemo(() => {
    const percentage = hasValue ? 2.5 : 0;
    const warn = percentage > 5;
    return {
      percentage,
      warn
    };
  }, [values]);
  const maxValues = useMemo(() => {
    const output = {
      firstToken: data.firstToken.available,
      secondToken: data.secondToken.available
    };
    const getFullValue = (token) => new BigNumber(data[token].available).times(data[token].price).toNumber();
    output[toTokenKey] = new BigNumber(getFullValue(fromTokenKey)).dividedBy(data[toTokenKey].price).toNumber();
    return output;
  }, [data.firstToken.available, data.secondToken.available, fromTokenKey, toTokenKey]);
  const setValue = ({
    percentage,
    tokenKey,
    value
  }) => {
    const tokenValues = {
      firstToken: 0,
      secondToken: 0
    };
    const calcTokenValue = (key) => {
      const tokenValue = new BigNumber(percentage).times(maxValues[key]).dividedBy(100).toNumber();
      return maxDecimals(tokenValue, 4);
    };
    if (value && tokenKey) {
      tokenValues[tokenKey] = value;
      const otherTokenKey = getOtherTokenKey(tokenKey);
      tokenValues[otherTokenKey] = calcTokenValue(otherTokenKey);
    } else {
      tokenValues.firstToken = calcTokenValue("firstToken");
      tokenValues.secondToken = calcTokenValue("secondToken");
    }
    setInputValue(firstTokenInput, tokenValues.firstToken);
    setInputValue(secondTokenInput, tokenValues.secondToken);
    const newValues = {
      percentage,
      firstToken: tokenValues.firstToken,
      secondToken: tokenValues.secondToken
    };
    setValues(newValues);
    return newValues;
  };
  const getOutput = (value = values) => {
    return {
      from: {
        token: data[fromTokenKey],
        amount: value[fromTokenKey]
      },
      to: {
        token: data[toTokenKey],
        amount: value[toTokenKey]
      },
      percentage: value.percentage,
      rates: getRates,
      fee: getFee,
      slippage: getSlippage
    };
  };
  const handleInput = (tokenKey, event) => {
    const token = data[tokenKey];
    const max = maxValues[tokenKey] || 0;
    let value = new BigNumber(event.target.value.replace(/[^0-9.]+/gi, "")).toNumber();
    value = maxDecimals(value, 4, "floor");
    if (isNaN(value) || value < 0)
      value = 0;
    if (value > max)
      value = max;
    const percentage = new BigNumber(value).times(100).dividedBy(max).toNumber();
    const newValues = setValue({
      percentage,
      tokenKey,
      value
    });
    if (onInput)
      onInput({
        token,
        value: getOutput(newValues),
        event
      });
  };
  const handleSlide = (percentage) => {
    const newValues = setValue({
      percentage
    });
    if (onInput)
      onInput({
        token: void 0,
        value: getOutput(newValues),
        event: "slide"
      });
  };
  const confirm = () => {
    if (onConfirm)
      onConfirm(getOutput());
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "uik-pool-actions__tokens",
      children: [/* @__PURE__ */ jsx(TokenComponent, {
        name: data[fromTokenKey].name,
        symbol: data[fromTokenKey].symbol,
        image: data[fromTokenKey].image,
        value: values[fromTokenKey],
        price: data[fromTokenKey].price,
        max: data[fromTokenKey].available,
        onInput: (e) => handleInput(fromTokenKey, e),
        onBlur: () => setInputValue(tokenInputs[fromTokenKey], values[fromTokenKey]),
        inputRef: tokenInputs[fromTokenKey]
      }), /* @__PURE__ */ jsx("div", {
        className: "uik-pool-actions__token-switch",
        children: /* @__PURE__ */ jsx("button", {
          type: "button",
          className: `
              uik-pool-actions__token-switch-btn
              ${fromTokenKey === "secondToken" ? "uik-pool-actions__token-switch-btn--reversed" : ""}
            `,
          onClick: switchTokens,
          children: /* @__PURE__ */ jsx(Icon, {
            icon: faRepeat
          })
        })
      }), /* @__PURE__ */ jsx(TokenComponent, {
        name: data[toTokenKey].name,
        symbol: data[toTokenKey].symbol,
        image: data[toTokenKey].image,
        onInput: (e) => handleInput(toTokenKey, e),
        onBlur: () => setInputValue(tokenInputs[toTokenKey], values[toTokenKey]),
        inputRef: tokenInputs[toTokenKey]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "uik-pool-actions__summary uik-pool-actions__trade-summary",
      children: [/* @__PURE__ */ jsx(SummaryItem, {
        label: "Rate",
        value: getRates.from.text,
        empty: !hasValue
      }), /* @__PURE__ */ jsx(SummaryItem, {
        label: "Fee",
        value: getFee.percentage ? `${getFee.percentage}%` : "0%",
        empty: !getFee.percentage
      }), /* @__PURE__ */ jsx(SummaryItem, {
        label: "Slippage",
        className: getSlippage.warn ? "uik-pool-actions__trade-slippage--warn" : "",
        value: `${getSlippage.percentage}%`,
        empty: !getSlippage.percentage
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "uik-pool-actions__slider",
      children: /* @__PURE__ */ jsx(Slider, {
        value: values.percentage,
        onChange: handleSlide,
        tooltip: `${maxDecimals(values.percentage, 2)}%`,
        helpers: [{
          position: 0,
          text: "0%"
        }, {
          position: 25
        }, {
          position: 50,
          text: "50%"
        }, {
          position: 75
        }, {
          position: 100,
          text: "100%"
        }]
      })
    }), /* @__PURE__ */ jsx(Button, {
      className: "uik-pool-actions__cta",
      fill: true,
      icon: faRepeat,
      text: "Trade",
      size: "large",
      disabled: !hasValue,
      onClick: confirm
    })]
  });
};
const PoolActions = ({
  onTabChange,
  onProvideInput,
  onWithdrawInput,
  onTradeInput,
  onProvide,
  onWithdraw,
  onTrade,
  onSwitchTokens,
  calcProvide,
  calcWithdraw,
  data,
  tab = "Trade",
  className
}) => {
  const [currentTab, setTab] = useState(tab);
  const selectTab = (value) => {
    if (onTabChange) {
      const from = currentTab;
      const to = value;
      onTabChange({
        from,
        to
      });
    }
    setTab(value);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: `
        uik-pool-actions
        ${className || ""}
      `,
    children: [/* @__PURE__ */ jsx("div", {
      className: "uik-pool-actions__top",
      children: /* @__PURE__ */ jsx(Tabs, {
        value: currentTab,
        onChange: (value) => selectTab(value),
        options: ["Trade", "Provide", "Withdraw"]
      })
    }), currentTab === "Provide" && /* @__PURE__ */ jsx(Provide, {
      data,
      onInput: onProvideInput,
      onConfirm: onProvide,
      calcValues: calcProvide
    }), currentTab === "Withdraw" && /* @__PURE__ */ jsx(Withdraw, {
      data,
      onInput: onWithdrawInput,
      onConfirm: onWithdraw,
      calcValues: calcWithdraw
    }), currentTab === "Trade" && /* @__PURE__ */ jsx(Trade, {
      data,
      onInput: onTradeInput,
      onConfirm: onTrade,
      onSwitchTokens
    })]
  });
};
const organisms = {
  AccountSelector,
  CopyButton,
  PoolActions
};
const components = {
  ...assets,
  ...atoms,
  ...molecules,
  ...organisms
};
const Prompt = ({
  type = "info",
  title,
  message,
  actions,
  onClose
}) => {
  const [isOpen, setOpen] = useState(false);
  const icons = {
    info: faCircleInfo,
    success: faCircleCheck,
    danger: faTriangleExclamation
  };
  const close = () => {
    setOpen(false);
    setTimeout(() => {
      if (onClose)
        onClose();
    }, 0.2 * 1e3);
  };
  useEffect(() => {
    if (!isOpen)
      setOpen(true);
    return () => {
    };
  }, []);
  const footer = useRef(null);
  const onOpened = () => {
    if (footer.current) {
      const buttons = footer.current.children;
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener("click", close);
      }
    }
  };
  return /* @__PURE__ */ jsx("div", {
    className: `
      uik-prompt
      uik-prompt--${type}
    `,
    children: /* @__PURE__ */ jsxs(Modal, {
      className: "uik-prompt__modal",
      title,
      isOpen,
      onClose: close,
      onOpened,
      footer: !!actions && /* @__PURE__ */ jsx("div", {
        ref: footer,
        className: "uik-prompt__actions",
        children: actions
      }),
      children: [/* @__PURE__ */ jsx(Icon, {
        className: "uik-prompt__icon",
        icon: icons[type]
      }), /* @__PURE__ */ jsx("span", {
        className: "uik-prompt__message",
        children: message
      })]
    })
  });
};
const hideScrollbar = () => document.body.style.overflow = "hidden";
const showScrollbar = () => document.body.style.overflow = "";
const prompt = ({
  type = "info",
  title,
  message,
  actions
}) => {
  const container2 = new Container("uik-prompt-container");
  hideScrollbar();
  container2.render(/* @__PURE__ */ jsx(Prompt, {
    type,
    title,
    message,
    actions,
    onClose: () => {
      showScrollbar();
      container2.destroy();
    }
  }));
};
const container = new Container("uik-celebrate-container");
const drop = (type) => {
  container.render(/* @__PURE__ */ jsx(Celebrate, {
    onDestroy: container.destroy,
    type
  }));
};
const celebrate = {
  dropConfetti: () => {
    drop("confetti");
  },
  dropMoney: () => {
    drop("money");
  }
};
const functions = {
  notify,
  prompt,
  ...celebrate
};
const slug = (str) => {
  if (!str)
    return "";
  return str.toLowerCase().replace(" ", "-");
};
const utils = {
  formatAddress,
  formatAmount,
  formatHumanAmount,
  maxDecimals,
  slug
};
const Uik = {
  ...components,
  ...functions,
  utils
};
export { Uik as default };
